/* SafeWake Theme JS — Phase 8 */
document.documentElement.classList.remove('no-js');
document.documentElement.classList.add('js');

/* Cache-buster for /products.json + /recommendations feeds, bucketed to 5 minutes.
   Shopify's CDN caches /products.json aggressively (minutes-to-an-hour), so
   JS-rendered cards (recommendations, FBT, cross-sell, infinite scroll) showed
   stale prices that lagged the Shopify backend. A per-LOAD timestamp fixed that
   but guaranteed a CDN miss on every single visit (perf audit 2026-09-12 T6).
   Flooring to a 5-minute bucket keeps stock/price freshness inside 5 minutes
   while letting every visitor in the same window share one cached response —
   and URLs are still identical within a load, so in-page caches dedupe. */
window.SW_PRICE_TS = Math.floor(Date.now() / 300000);
function swFresh(url) {
  return url + (url.indexOf('?') === -1 ? '?' : '&') + '_sw=' + window.SW_PRICE_TS;
}

/* ── perf batch 3 (2026-09-12) — RUNTIME CARD IMAGES ─────────────────────────
   The card renderers in this file build <img> straight from feed URLs
   (/products.json, /recommendations/products.json, /search/suggest.json). Those
   feeds hand back ORIGINAL-size files, and the Ajax feeds hand them back
   PROTOCOL-RELATIVE ("//cdn.shopify.com/s/files/..."), which the old
   `indexOf('http') === 0` guard skipped — so every recommendation card pulled the
   full-size PNG (measured live 2026-09-12: 462 KB / 314 KB / 167 KB on one product
   page). Shopify's CDN honours width=N on any cdn.shopify.com/s/files/... or
   <shop>/cdn/shop/... URL (?width= when clean, &width= when a ?v= is already
   there). swImgAttrs() emits the same src + 1x/2x srcset + sizes + width/height
   shape as snippets/sw-product-card.liquid, so a JS card and a Liquid card
   resolve to the same rendition. Non-Shopify URLs and data: URIs pass through
   untouched; a URL that already carries width= is never rewritten. */
function swImg(url, width) {
  if (!url) return '';
  if (typeof url === 'object') url = url.src || url.url || '';
  url = String(url);
  if (!url || url.indexOf('data:') === 0) return url;
  if (!/cdn\.shopify\.com\/|\/cdn\/shop\//.test(url)) return url;
  if (/[?&]width=\d/.test(url)) return url;
  return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + width;
}
function swSrcset(url, slot) {
  var one = swImg(url, slot), two = swImg(url, slot * 2);
  return (one && two && one !== two) ? one + ' ' + slot + 'w, ' + two + ' ' + (slot * 2) + 'w' : '';
}
/* o = { src: <px for the plain src>, slot: <CSS px the card renders at>,
         sizes?: <sizes attr, defaults to "<slot>px">, w?/h?: <width/height attrs> } */
function swImgAttrs(url, o) {
  var src = swImg(url, o.src);
  if (!src) return '';
  var q = function(s) { return String(s).replace(/"/g, '&quot;'); };
  var a = ' src="' + q(src) + '"';
  var set = swSrcset(url, o.slot);
  if (set) a += ' srcset="' + q(set) + '" sizes="' + q(o.sizes || (o.slot + 'px')) + '"';
  var w = o.w != null ? o.w : o.slot;
  return a + ' width="' + w + '" height="' + (o.h != null ? o.h : w) + '"';
}
window.swImg = swImg;
window.swSrcset = swSrcset;

/* === Global toast: slides down from top, auto-dismiss ===
   Exposed as window.swToast(msg, opts?). Used by cart-add handlers
   to confirm "Added to cart" immediately — no guessing. */
(function() {
  var el = null, dismissTimer = null;
  function ensureEl() {
    if (el) return el;
    el = document.createElement('div');
    el.className = 'sw-toast';
    el.setAttribute('role', 'status');
    el.setAttribute('aria-live', 'polite');
    el.setAttribute('aria-atomic', 'true');
    document.body.appendChild(el);
    return el;
  }
  window.swToast = function(message, opts) {
    opts = opts || {};
    var dur = opts.duration || 2400;
    var variant = opts.variant || 'success'; /* success | info | error */
    var node = ensureEl();
    node.className = 'sw-toast sw-toast--' + variant;
    /* Simple SVG checkmark / icon prefix */
    var icon = variant === 'success'
      ? '<svg class="sw-toast__icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="20 6 9 17 4 12"/></svg>'
      : variant === 'error'
      ? '<svg class="sw-toast__icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>'
      : '<svg class="sw-toast__icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/></svg>';
    node.innerHTML = icon + '<span class="sw-toast__msg"></span>';
    node.querySelector('.sw-toast__msg').textContent = message;
    /* Force reflow so the transition kicks in on re-show */
    void node.offsetWidth;
    node.classList.add('is-visible');
    if (dismissTimer) clearTimeout(dismissTimer);
    dismissTimer = setTimeout(function() {
      node.classList.remove('is-visible');
    }, dur);
  };
})();

/* === Mobile Menu === */
(function() {
  var menu = document.getElementById('mobile-menu');
  var openBtn = document.getElementById('mobile-menu-open');
  var closeBtn = document.getElementById('mobile-menu-close');
  var backdrop = document.getElementById('mobile-menu-backdrop');
  if (!menu || !openBtn) return;

  function open() {
    menu.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }
  function close() {
    menu.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  openBtn.addEventListener('click', open);
  if (closeBtn) closeBtn.addEventListener('click', close);
  if (backdrop) backdrop.addEventListener('click', close);
  /* WS-19 (2026-09-07): Escape closes the menu and unlocks body scroll, like the search overlay already does */
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && menu.classList.contains('is-open')) { close(); openBtn.focus(); }
  });
})();

/* === Cart Drawer === */
(function() {
  var drawer = document.getElementById('cart-drawer');
  if (!drawer) return;

  window.openCartDrawer = function() {
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  };
  window.closeCartDrawer = function() {
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  };

  /* Delegated close handlers — survive innerHTML refreshes from Section API */
  drawer.addEventListener('click', function(e) {
    if (e.target && (e.target.id === 'cart-drawer-close' || e.target.closest('#cart-drawer-close'))) {
      window.closeCartDrawer();
    }
    if (e.target && e.target.id === 'cart-drawer-backdrop') {
      window.closeCartDrawer();
    }
    if (e.target.closest('[data-cart-close-link]')) {
      /* Links inside drawer — close drawer before navigating */
      window.closeCartDrawer();
    }
  });

  /* Cart icon buttons open the drawer */
  document.addEventListener('click', function(e) {
    var btn = e.target.closest('[data-cart-open]');
    if (!btn) return;
    e.preventDefault();
    window.openCartDrawer();
  });

  /* Esc key closes */
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && drawer.classList.contains('is-open')) window.closeCartDrawer();
  });
})();

/* === Cart Drawer Item Controls (qty, remove) === */
(function() {
  var drawer = document.getElementById('cart-drawer');
  if (!drawer) return;

  function refreshDrawer() {
    return fetch('/?sections=cart-drawer', { headers: { 'Accept': 'application/json' } })
      .then(function(r) { return r.json(); })
      .then(function(sections) {
        if (!sections || !sections['cart-drawer']) return;
        var wrapper = document.createElement('div');
        wrapper.innerHTML = sections['cart-drawer'];
        var fresh = wrapper.querySelector('#cart-drawer');
        if (fresh && drawer) {
          var wasOpen = drawer.classList.contains('is-open');
          drawer.innerHTML = fresh.innerHTML;
          if (wasOpen) drawer.classList.add('is-open');
        }
      });
  }

  function changeQty(key, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        document.querySelectorAll('.header__cart-count').forEach(function(el) {
          el.textContent = cart.item_count;
          el.style.display = cart.item_count > 0 ? 'flex' : 'none';
        });
        return refreshDrawer();
      });
  }

  /* Delegated click — +/−, remove */
  drawer.addEventListener('click', function(e) {
    var qtyBtn = e.target.closest('[data-cart-qty-btn]');
    if (qtyBtn) {
      var key = qtyBtn.getAttribute('data-key');
      var delta = parseInt(qtyBtn.getAttribute('data-delta'), 10) || 0;
      /* v7 fix: line item key contains a colon (VARIANT_ID:HASH) which breaks CSS attribute selectors.
         Instead, find the input by walking up to the cart-drawer__item container. */
      var itemEl = qtyBtn.closest('.cart-drawer__item');
      var input = itemEl ? itemEl.querySelector('[data-cart-qty-input]') : null;
      if (!input) return;
      var next = Math.max(0, (parseInt(input.value, 10) || 0) + delta);
      input.value = next;
      changeQty(key, next);
      return;
    }
    var removeBtn = e.target.closest('[data-cart-remove]');
    if (removeBtn) {
      changeQty(removeBtn.getAttribute('data-key'), 0);
      return;
    }
  });

  /* Delegated change on qty input */
  drawer.addEventListener('change', function(e) {
    var input = e.target.closest('[data-cart-qty-input]');
    if (!input) return;
    var qty = Math.max(0, parseInt(input.value, 10) || 0);
    changeQty(input.getAttribute('data-key'), qty);
  });

  /* v7: Site-wide safety handler for cart qty buttons — catches main-cart, cart-drawer, and any future cart surface */
  document.addEventListener('click', function(e) {
    var btn = e.target.closest('[data-cart-qty-btn], [data-cart-qty]');
    if (!btn) return;
    var key = btn.getAttribute('data-key');
    if (!key) return;
    var delta = parseInt(btn.getAttribute('data-delta'), 10) || 0;
    if (!delta) return;
    e.preventDefault();
    var container = btn.closest('.cart-item, .cart-drawer__item');
    var input = container ? container.querySelector('input[type="number"], [data-cart-qty-input]') : null;
    var currentQty = input ? parseInt(input.value, 10) || 0 : 1;
    var nextQty = Math.max(0, currentQty + delta);
    if (input) input.value = nextQty;
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: nextQty })
    }).then(function() {
      if (window.location.pathname === '/cart') window.location.reload();
      else if (typeof window.refreshCartDrawer === 'function') window.refreshCartDrawer();
    });
  }, true); /* capture phase so it fires before anything that might preventDefault */
})();

/* === Product Gallery Thumbnails === */
(function() {
  var thumbs = document.querySelectorAll('.product-gallery__thumb');
  var mainImg = document.getElementById('main-product-img');
  if (!mainImg || thumbs.length === 0) return;

  thumbs.forEach(function(thumb) {
    thumb.addEventListener('click', function() {
      var url = this.getAttribute('data-image-url');
      if (url) {
        mainImg.src = url;
        thumbs.forEach(function(t) { t.classList.remove('active'); });
        this.classList.add('active');
      }
    });
  });
})();

/* === Product Gallery Touch Swipe + Mouse Drag === */
(function() {
  var mainImg = document.getElementById('main-product-img');
  var gallery = mainImg ? mainImg.closest('.product-gallery__main') : null;
  var thumbs = document.querySelectorAll('.product-gallery__thumb');
  if (!gallery || thumbs.length < 2) return;
  var startX = 0, startY = 0, dragAxis = null, isDragging = false;
  var currentIndex = 0;
  thumbs.forEach(function(t, i) { if (t.classList.contains('active')) currentIndex = i; });
  function goToThumb(index) {
    if (index < 0) index = thumbs.length - 1;
    if (index >= thumbs.length) index = 0;
    currentIndex = index;
    var thumb = thumbs[currentIndex];
    var url = thumb.getAttribute('data-image-url');
    if (url && mainImg) {
      mainImg.style.opacity = '0';
      mainImg.style.transition = 'opacity 0.15s ease';
      setTimeout(function() { mainImg.src = url; mainImg.style.opacity = '1'; }, 150);
    }
    thumbs.forEach(function(t) { t.classList.remove('active'); });
    thumb.classList.add('active');
    thumb.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
  }
  gallery.addEventListener('touchstart', function(e) {
    startX = e.touches[0].clientX;
    startY = e.touches[0].clientY;
    isDragging = true; dragAxis = null;
  }, { passive: true });
  gallery.addEventListener('touchmove', function(e) {
    if (!isDragging || dragAxis) return;
    var dx = Math.abs(e.touches[0].clientX - startX);
    var dy = Math.abs(e.touches[0].clientY - startY);
    if (dx > 8 || dy > 8) {
      dragAxis = dx > dy ? 'x' : 'y';
      if (dragAxis === 'x') e.preventDefault();
    }
  }, { passive: false });
  gallery.addEventListener('touchend', function(e) {
    if (!isDragging) return;
    isDragging = false;
    if (dragAxis !== 'x') return;
    var diff = startX - e.changedTouches[0].clientX;
    if (Math.abs(diff) > 40) {
      if (diff > 0) goToThumb(currentIndex + 1);
      else goToThumb(currentIndex - 1);
    }
  });
  gallery.style.cursor = 'grab';
  var mouseDown = false, mouseStartX = 0;
  gallery.addEventListener('mousedown', function(e) {
    mouseDown = true; mouseStartX = e.clientX;
    gallery.style.cursor = 'grabbing'; e.preventDefault();
  });
  document.addEventListener('mouseup', function(e) {
    if (!mouseDown) return;
    mouseDown = false; gallery.style.cursor = 'grab';
    var diff = mouseStartX - e.clientX;
    if (Math.abs(diff) > 40) {
      if (diff > 0) goToThumb(currentIndex + 1);
      else goToThumb(currentIndex - 1);
    }
  });
})();

/* === Quantity Buttons === */
(function() {
  document.addEventListener('click', function(e) {
    var btn = e.target.closest('[data-qty-minus], [data-qty-plus]');
    if (!btn) return;
    var container = btn.closest('.product-form__qty, .cart-item__qty');
    if (!container) return;
    var input = container.querySelector('input[type="number"]');
    if (!input) return;
    var val = parseInt(input.value) || 1;
    var min = parseInt(input.min) || 0;
    if (btn.hasAttribute('data-qty-minus')) {
      if (val > min) input.value = val - 1;
    } else {
      input.value = val + 1;
    }
  });
})();

/* === Cookie Consent === */
(function() {
  var banner = document.getElementById('cookie-consent');
  var acceptBtn = document.getElementById('cookie-accept');
  var declineBtn = document.getElementById('cookie-decline');
  if (!banner) return;
  function getCookie(name) {
    var match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
    return match ? match[2] : null;
  }
  if (!getCookie('sw_cookie_consent')) banner.classList.add('is-visible');
  var days = parseInt(banner.getAttribute('data-cookie-days')) || 30;
  function dismiss(value) {
    document.cookie = 'sw_cookie_consent=' + value + ';path=/;max-age=' + (days * 86400) + ';SameSite=Lax';
    banner.classList.remove('is-visible');
  }
  if (acceptBtn) acceptBtn.addEventListener('click', function() { dismiss('accepted'); });
  if (declineBtn) declineBtn.addEventListener('click', function() { dismiss('declined'); });
})();

/* === AJAX Add to Cart (delegated — catches dynamically-added forms) === */
(function() {
  function refreshDrawer() {
    /* WS-19 (2026-09-07): the drawer only exists when sections/overlay-group.json mounts it — without it every
       add-to-cart paid a 10 KB section fetch that was discarded (and the success toast waited on it). */
    if (!document.getElementById('cart-drawer')) return Promise.resolve(null);
    return fetch('/?sections=cart-drawer', { headers: { 'Accept': 'application/json' } })
      .then(function(r) { return r.json(); })
      .then(function(sections) {
        if (!sections || !sections['cart-drawer']) return;
        var wrapper = document.createElement('div');
        wrapper.innerHTML = sections['cart-drawer'];
        var fresh = wrapper.querySelector('#cart-drawer');
        var existing = document.getElementById('cart-drawer');
        if (fresh && existing) {
          var wasOpen = existing.classList.contains('is-open');
          existing.innerHTML = fresh.innerHTML;
          /* Re-bind close handlers since innerHTML replaced the DOM */
          var closeBtn = existing.querySelector('#cart-drawer-close');
          var backdrop = existing.querySelector('#cart-drawer-backdrop');
          if (closeBtn && window.closeCartDrawer) closeBtn.addEventListener('click', window.closeCartDrawer);
          if (backdrop && window.closeCartDrawer) backdrop.addEventListener('click', window.closeCartDrawer);
          if (wasOpen) existing.classList.add('is-open');
        }
      })
      .catch(function(){});
  }

  document.addEventListener('submit', function(e) {
    var form = e.target.closest('form[action="/cart/add"], form[action^="/cart/add"]');
    if (!form) return;
    e.preventDefault();

    /* Detect Quick Checkout / Buy Now intent — button either has data-buy-now OR name="checkout" */
    var submitter = e.submitter || form.querySelector('[type="submit"]');
    var isBuyNow = submitter && (submitter.hasAttribute('data-buy-now') || submitter.name === 'checkout');

    var formData = new FormData(form);
    var btn = submitter || form.querySelector('[type="submit"]');
    var originalHtml = btn ? btn.innerHTML : '';
    if (btn) {
      btn.disabled = true;
      btn.classList.add('is-loading');
      if (!btn.querySelector('svg') && !isBuyNow) btn.textContent = 'Adding…';
    }

    /* Visual: fly-to-cart animation from the card image if we can find one */
    try { flyToCart(form); } catch (e2) {}

    fetch('/cart/add.js', { method: 'POST', body: formData })
      .then(function(res) { return res.json().then(function(body) { if (!res.ok) { var e = new Error((body && (body.description || body.message)) || 'Could not add to cart'); e.cartError = body; throw e; } return body; }); })
      .then(function() {
        if (isBuyNow) {
          /* Skip drawer, go straight to checkout */
          window.location.href = '/checkout';
          return null;
        }
        /* Success pulse on the button */
        if (btn) {
          btn.classList.remove('is-loading');
          btn.classList.add('is-success');
          if (!btn.querySelector('svg')) btn.textContent = '✓ Added';
        }
        return Promise.all([
          fetch('/cart.js').then(function(r) { return r.json(); }),
          refreshDrawer()
        ]);
      })
      .then(function(results) {
        if (!results) return; /* buy-now path */
        var cart = results[0];
        if (cart) {
          document.querySelectorAll('.header__cart-count').forEach(function(el) {
            el.textContent = cart.item_count;
            el.style.display = cart.item_count > 0 ? 'flex' : 'none';
            el.classList.remove('header__cart-count--bounce');
            /* Re-trigger bounce animation */
            void el.offsetWidth;
            el.classList.add('header__cart-count--bounce');
          });
        }
        /* Toast-only confirmation. CPO audit: toast + drawer = double confirmation
           interruption. Drawer stays accessible via the header cart icon. */
        if (window.swToast) window.swToast('Added to cart · بكل بساطة');
        setTimeout(function() {
          if (btn) {
            btn.disabled = false;
            btn.classList.remove('is-success');
            btn.innerHTML = originalHtml;
          }
        }, 1400);
      })
      .catch(function() {
        if (window.swToast) window.swToast('Could not add item', { variant: 'error' });
        if (btn) {
          btn.disabled = false;
          btn.classList.remove('is-loading');
          btn.innerHTML = originalHtml;
        }
      });
  });

  /* Fly-to-cart animation: clones the product image and animates it toward the cart icon */
  function flyToCart(form) {
    var ctx = form.closest('[data-cart-item], .coll-product-card, .featured-products__card, .bundle-card, .cart-upsell-card, .rec-card, .product-info');
    var img = (ctx && ctx.querySelector('img')) || document.getElementById('main-product-img');
    var target = document.querySelector('.header__cart-count, [data-cart-open] svg, [data-cart-open]');
    if (!img || !target) return;
    var from = img.getBoundingClientRect();
    var to = target.getBoundingClientRect();
    var clone = img.cloneNode(true);
    clone.style.cssText = 'position:fixed;z-index:9999;top:' + from.top + 'px;left:' + from.left + 'px;width:' + from.width + 'px;height:' + from.height + 'px;border-radius:12px;object-fit:contain;padding:8px;background:rgb(var(--color-card));box-shadow:0 8px 32px rgba(0,0,0,0.2);transition:transform 0.7s cubic-bezier(0.4, 0, 0.2, 1), opacity 0.7s;pointer-events:none;';
    document.body.appendChild(clone);
    /* Force reflow then animate */
    void clone.offsetWidth;
    var dx = (to.left + to.width / 2) - (from.left + from.width / 2);
    var dy = (to.top + to.height / 2) - (from.top + from.height / 2);
    clone.style.transform = 'translate(' + dx + 'px, ' + dy + 'px) scale(0.15)';
    clone.style.opacity = '0.1';
    setTimeout(function() { if (clone.parentNode) clone.parentNode.removeChild(clone); }, 720);
  }
})();

/* === Hero Carousel — true seamless infinite loop (cloned edge slides) === */
(function() {
  document.querySelectorAll('[data-hero-carousel]').forEach(function(container) {
    var track = container.querySelector('[data-carousel-track]');
    var wrapper = container.closest('.hero-section__inner') || container.parentElement;
    var dots = wrapper.querySelectorAll('[data-carousel-dot]');
    if (!track) return;
    var realSlides = Array.prototype.slice.call(track.children);
    var n = realSlides.length;
    if (n < 2) return;

    /* Clone last slide at the start, and first slide at the end */
    var firstClone = realSlides[0].cloneNode(true);
    var lastClone = realSlides[n - 1].cloneNode(true);
    firstClone.setAttribute('aria-hidden', 'true');
    lastClone.setAttribute('aria-hidden', 'true');
    firstClone.setAttribute('data-clone', 'first');
    lastClone.setAttribute('data-clone', 'last');
    track.appendChild(firstClone);
    track.insertBefore(lastClone, track.firstChild);

    /* Logical index: 1..n map to real slides, 0 = lastClone, n+1 = firstClone */
    var index = 1;
    var DURATION = 550;
    var TRANS = 'transform ' + DURATION + 'ms cubic-bezier(0.22, 1, 0.36, 1)';
    track.style.transition = TRANS;
    track.style.transform = 'translateX(-' + (index * 100) + '%)';

    var startX = 0, startY = 0;
    var isDragging = false;
    var dragAxis = null; /* 'x' | 'y' | null */
    var autoTimer;
    var animating = false;

    function setDots() {
      var real = ((index - 1) % n + n) % n;
      dots.forEach(function(d, i) { d.classList.toggle('active', i === real); });
    }

    function snapAfterTransition() {
      /* When we animated onto a clone, jump (no transition) to the real slide */
      if (index === 0) {
        track.style.transition = 'none';
        index = n;
        track.style.transform = 'translateX(-' + (index * 100) + '%)';
        /* Force reflow so the next transition is seen */
        void track.offsetWidth;
        track.style.transition = TRANS;
      } else if (index === n + 1) {
        track.style.transition = 'none';
        index = 1;
        track.style.transform = 'translateX(-' + (index * 100) + '%)';
        void track.offsetWidth;
        track.style.transition = TRANS;
      }
      animating = false;
    }
    track.addEventListener('transitionend', snapAfterTransition);

    function goNext() {
      if (animating) return;
      animating = true;
      index++;
      track.style.transition = TRANS;
      track.style.transform = 'translateX(-' + (index * 100) + '%)';
      setDots();
    }
    function goPrev() {
      if (animating) return;
      animating = true;
      index--;
      track.style.transition = TRANS;
      track.style.transform = 'translateX(-' + (index * 100) + '%)';
      setDots();
    }
    function goToReal(realIdx) {
      if (animating) return;
      animating = true;
      index = realIdx + 1;
      track.style.transition = TRANS;
      track.style.transform = 'translateX(-' + (index * 100) + '%)';
      setDots();
    }

    /* Touch */
    track.addEventListener('touchstart', function(e) {
      startX = e.touches[0].clientX;
      startY = e.touches[0].clientY;
      isDragging = true; dragAxis = null;
      clearInterval(autoTimer);
    }, { passive: true });
    track.addEventListener('touchmove', function(e) {
      if (!isDragging || dragAxis) return;
      var dx = Math.abs(e.touches[0].clientX - startX);
      var dy = Math.abs(e.touches[0].clientY - startY);
      if (dx > 8 || dy > 8) dragAxis = dx > dy ? 'x' : 'y';
    }, { passive: true });
    track.addEventListener('touchend', function(e) {
      if (!isDragging) return;
      isDragging = false;
      var diff = startX - e.changedTouches[0].clientX;
      if (dragAxis === 'x' && Math.abs(diff) > 40) {
        if (diff > 0) goNext(); else goPrev();
      }
      startAutoAdvance();
    });

    /* Mouse */
    track.addEventListener('mousedown', function(e) {
      startX = e.clientX; isDragging = true;
      clearInterval(autoTimer); track.style.cursor = 'grabbing';
      e.preventDefault();
    });
    document.addEventListener('mouseup', function(e) {
      if (!isDragging) return;
      isDragging = false; track.style.cursor = '';
      var diff = startX - e.clientX;
      if (Math.abs(diff) > 50) { if (diff > 0) goNext(); else goPrev(); }
      startAutoAdvance();
    });

    /* Dots */
    dots.forEach(function(dot, i) {
      dot.addEventListener('click', function() {
        goToReal(i);
        clearInterval(autoTimer);
        startAutoAdvance();
      });
    });

    function startAutoAdvance() {
      clearInterval(autoTimer);
      autoTimer = setInterval(goNext, 6000);
    }
    startAutoAdvance();

    /* Pause when tab is hidden to avoid a jump when coming back */
    document.addEventListener('visibilitychange', function() {
      if (document.hidden) clearInterval(autoTimer);
      else startAutoAdvance();
    });
  });
})();

/* === Unified Drag + Swipe with Click Prevention === */
(function() {
  /* Detect real mouse (no touch screen) — touch devices rely on native overflow scroll. */
  var hasTouch = ('ontouchstart' in window) || (navigator.maxTouchPoints > 0);

  document.querySelectorAll('[data-scroll-container]').forEach(function(container) {
    /* --- Shared state --- */
    var dragged = false;

    /* --- MOUSE: Momentum drag (desktop) --- */
    var isDown = false, startX, scrollLeft, lastX, lastTime, velocity, animFrame;

    function stopMomentum() { if (animFrame) cancelAnimationFrame(animFrame); }

    function applyMomentum() {
      if (Math.abs(velocity) < 0.5) return;
      container.scrollLeft -= velocity;
      velocity *= 0.95;
      animFrame = requestAnimationFrame(applyMomentum);
    }

    container.addEventListener('mousedown', function(e) {
      /* If this mousedown was synthesized from a touch, skip — let native scroll handle it. */
      if (hasTouch && e.pointerType === 'touch') return;
      stopMomentum();
      isDown = true;
      dragged = false;
      container.style.cursor = 'grabbing';
      startX = e.pageX;
      scrollLeft = container.scrollLeft;
      lastX = e.pageX;
      lastTime = Date.now();
      velocity = 0;
      e.preventDefault();
    });

    container.addEventListener('mousemove', function(e) {
      if (!isDown) return;
      e.preventDefault();
      var x = e.pageX;
      var totalDx = Math.abs(x - startX);
      if (totalDx > 5) dragged = true; /* flag: this was a drag, not a click */
      container.scrollLeft = scrollLeft - (x - startX);
      var now = Date.now();
      var dt = now - lastTime;
      if (dt > 0) {
        var instant = (x - lastX) / dt * 16; /* normalize to ~60fps */
        /* Low-pass filter — new samples weighted 0.7, old 0.3. Kills stale velocity naturally. */
        velocity = instant * 0.7 + velocity * 0.3;
      }
      lastX = x;
      lastTime = now;
    });

    function mouseRelease() {
      if (!isDown) return;
      isDown = false;
      container.style.cursor = '';
      /* If user held still before releasing, kill stale velocity */
      var idle = Date.now() - lastTime;
      if (idle > 80) velocity = 0;
      if (Math.abs(velocity) > 1) applyMomentum();
    }

    container.addEventListener('mouseup', mouseRelease);
    container.addEventListener('mouseleave', mouseRelease);

    /* --- TOUCH: Swipe detection (mobile) --- */
    var touchStartX = 0, touchStartY = 0;

    container.addEventListener('touchstart', function(e) {
      touchStartX = e.touches[0].clientX;
      touchStartY = e.touches[0].clientY;
      dragged = false;
    }, { passive: true });

    container.addEventListener('touchmove', function(e) {
      var dx = Math.abs(e.touches[0].clientX - touchStartX);
      var dy = Math.abs(e.touches[0].clientY - touchStartY);
      if (dx > 10 && dx > dy) dragged = true;
    }, { passive: true });

    /* --- CLICK PREVENTION: Works for both mouse AND touch --- */
    container.addEventListener('click', function(e) {
      if (dragged) {
        e.preventDefault();
        e.stopPropagation();
        dragged = false;
      }
    }, true); /* capture phase = runs before any <a> click handlers */
  });
})();

/* === Scroll Arrow Buttons === */
(function() {
  document.querySelectorAll('[data-scroll-prev], [data-scroll-next]').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var wrap = btn.closest('.scroll-wrap');
      if (!wrap) return;
      var container = wrap.querySelector('[data-scroll-container]');
      if (!container) return;
      var dir = btn.hasAttribute('data-scroll-prev') ? -1 : 1;
      container.scrollBy({ left: dir * 300, behavior: 'smooth' });
    });
  });
})();

/* === Brand Showcase Tab Switching (legacy) === */
(function() {
  document.addEventListener('click', function(e) {
    var tab = e.target.closest('[data-brand-tab]');
    if (!tab) return;
    var block = tab.closest('.brand-showcase__block');
    if (!block) return;
    var handle = tab.getAttribute('data-brand-tab');
    block.querySelectorAll('[data-brand-tab]').forEach(function(t) { t.classList.toggle('active', t === tab); });
    block.querySelectorAll('[data-brand-panel]').forEach(function(panel) { panel.style.display = panel.getAttribute('data-brand-panel') === handle ? 'block' : 'none'; });
  });
})();

/* === Collection Tabs Switching + Pill Strip Swipe ===
   Touch: fully native via `overflow-x: auto` + `-webkit-overflow-scrolling: touch`.
   A JS touchmove+preventDefault handler KILLS iOS native momentum scroll, so we
   deliberately attach NO touch listeners to the pill strip.
   Mouse: hold-drag scrolls the strip on desktop.
   Click suppression: a capture-phase guard kills the phantom click that fires
   at the end of a mouse drag AND the click that fires at the end of a native
   scroll (via scroll timestamp). */
(function() {
  /* Lazy panels (perf batch 2, 2026-09-12). Only the ACTIVE panel ships its 12 cards in the HTML;
     every other panel ships a skeleton plus data-panel-url, and its cards are fetched on first
     activation through Shopify's Section Rendering API:
         GET <collection url>?section_id=sw-collection-panel
     The URL is RELATIVE to the current document, so the market cookie rides along and the cards
     come back in the visitor's own currency. Responses are cached per URL for the life of the page
     and the cache is shared by every [data-collection-tabs] section on the page, so the same
     collection appearing in both home-page tab strips is fetched once.
     Nothing else needs re-initialising: the drag / momentum / arrow handlers are bound to
     [data-scroll-container] and the arrow buttons, both of which shipped with the skeleton. */
  var panelCache = {};
  function swLoadPanel(panel) {
    if (!panel) return;
    var url = panel.getAttribute('data-panel-url');
    if (!url || panel.getAttribute('data-panel-loaded')) return;
    var container = panel.querySelector('[data-scroll-container]');
    if (!container) return;
    panel.setAttribute('data-panel-loaded', 'pending');
    var href = url + (url.indexOf('?') === -1 ? '?' : '&') + 'section_id=sw-collection-panel';
    if (!panelCache[href]) {
      panelCache[href] = fetch(href, { credentials: 'same-origin' }).then(function(r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.text();
      });
    }
    panelCache[href].then(function(html) {
      var cards = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-panel-cards]');
      if (!cards || !cards.children.length) throw new Error('no cards in response');
      container.innerHTML = cards.innerHTML;
      container.scrollLeft = 0;
      panel.setAttribute('data-panel-loaded', '1');
      /* price-dual.js rewrites .collection-tabs__price and already watches document.body with a
         MutationObserver; calling its sweep directly converts the swapped-in cards in this frame
         instead of the next one. GUARDED on <html data-price-dual>, which price-dual only sets on
         markets where it actually runs — on AE (base market = presented currency) it returns early
         and installs no observer, and sweeping there would wrap AED prices in .sw-price spans that
         the server-rendered cards do not have. */
      if (document.documentElement.hasAttribute('data-price-dual') && window.SWPriceDual && typeof window.SWPriceDual.sweep === 'function') window.SWPriceDual.sweep();
    }).catch(function(e) {
      /* Leave the skeleton up and let the next click retry rather than showing an empty strip. */
      panel.removeAttribute('data-panel-loaded');
      delete panelCache[href];
      if (window.console && console.warn) console.warn('[collection-tabs] panel load failed', href, e && e.message);
    });
  }

  document.querySelectorAll('[data-collection-tabs]').forEach(function(section) {
    var pills = section.querySelectorAll('[data-tab-btn]');
    var panels = section.querySelectorAll('[data-tab-panel]');
    var pillStrip = section.querySelector('.collection-tabs__pills');
    if (pills.length === 0) return;

    /* Shared suppression flags */
    var mouseDragged = false;
    var lastScrollAt = 0;

    pills.forEach(function(pill) {
      pill.addEventListener('click', function(e) {
        if (mouseDragged || (Date.now() - lastScrollAt) < 120) {
          e.preventDefault();
          e.stopPropagation();
          mouseDragged = false;
          return;
        }
        var id = pill.getAttribute('data-tab-btn');
        pills.forEach(function(p) { p.classList.toggle('active', p === pill); });
        var activePanel = null;
        panels.forEach(function(panel) { var on = panel.getAttribute('data-tab-panel') === id; panel.classList.toggle('active', on); if (on) activePanel = panel; });
        swLoadPanel(activePanel);
        var headingEl = section.querySelector('[data-tabs-heading]');
        if (headingEl) headingEl.textContent = pill.textContent.trim();
      });
    });

    if (!pillStrip) return;

    /* Native scroll timestamp — any scroll (touch, trackpad, or wheel) marks
       a short suppression window so the next click isn't interpreted as tab. */
    pillStrip.addEventListener('scroll', function() { lastScrollAt = Date.now(); }, { passive: true });

    /* Mouse drag — desktop only. No touch events touched here. */
    var isDown = false, startX = 0, startScroll = 0;

    pillStrip.addEventListener('mousedown', function(e) {
      if (e.button !== 0) return;
      isDown = true;
      mouseDragged = false;
      startX = e.pageX;
      startScroll = pillStrip.scrollLeft;
      pillStrip.style.cursor = 'grabbing';
    });
    document.addEventListener('mousemove', function(e) {
      if (!isDown) return;
      var dx = e.pageX - startX;
      if (Math.abs(dx) > 4) mouseDragged = true;
      pillStrip.scrollLeft = startScroll - dx;
    });
    document.addEventListener('mouseup', function() {
      if (!isDown) return;
      isDown = false;
      pillStrip.style.cursor = '';
    });

    /* Capture-phase click block — kills click fired at end of mouse drag or
       right after a native scroll. */
    pillStrip.addEventListener('click', function(e) {
      if (mouseDragged || (Date.now() - lastScrollAt) < 120) {
        e.preventDefault();
        e.stopPropagation();
        mouseDragged = false;
      }
    }, true);
  });
})();

/* === Search Overlay with Live Autocomplete === */
(function() {
  var overlay = document.getElementById('search-overlay');
  if (!overlay) return;
  var input = overlay.querySelector('.search-overlay__input');
  var resultsPanel = overlay.querySelector('#search-results');
  var list = overlay.querySelector('[data-search-list]');
  var footer = overlay.querySelector('[data-search-footer]');
  var form = overlay.querySelector('form');
  var debounceTimer = null;
  var lastQ = '';

  window.openSearch = function() {
    overlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    if (input) setTimeout(function() { input.focus(); }, 50);
  };
  window.closeSearch = function() {
    overlay.classList.remove('is-open');
    document.body.style.overflow = '';
  };

  document.querySelectorAll('[data-search-open]').forEach(function(btn) {
    btn.addEventListener('click', function(e) { e.preventDefault(); window.openSearch(); });
  });
  var closeBtn = overlay.querySelector('[data-search-close]');
  if (closeBtn) closeBtn.addEventListener('click', window.closeSearch);
  var backdrop = overlay.querySelector('.search-overlay__backdrop');
  if (backdrop) backdrop.addEventListener('click', window.closeSearch);
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && overlay.classList.contains('is-open')) window.closeSearch();
  });

  /* WS-19 (2026-09-07): /search/suggest.json hands back a bare decimal ("2832.71", no currency). Format it through the ONE
     formatter so the overlay shows "Dhs. 2,832.71" on AE and price-dual has a currency token to convert on the other five. */
  function fmtSuggestPrice(v) {
    var n = parseFloat(v);
    if (window.SWMoney && isFinite(n)) { try { return escapeHtml(SWMoney.formatMoney(SWMoney.fromDecimal(n))); } catch (e) {} }
    return escapeHtml(String(v));
  }
  function renderResults(data, q) {
    if (!data || !data.resources || !data.resources.results) { renderEmpty(q); return; }
    var products = data.resources.results.products || [];
    var collections = data.resources.results.collections || [];
    if (!products.length && !collections.length) { renderEmpty(q); return; }

    var html = '';
    collections.slice(0, 3).forEach(function(c) {
      html += '<a href="' + c.url + '" class="search-overlay__item" role="option">' +
        '<div class="search-overlay__item-img" style="display:flex;align-items:center;justify-content:center;color:rgb(var(--color-muted));font-size:.7rem;">COL</div>' +
        '<div class="search-overlay__item-body">' +
        '<p class="search-overlay__item-title">' + escapeHtml(c.title) + '</p>' +
        '<p class="search-overlay__item-vendor">Collection</p>' +
        '</div></a>';
    });
    products.slice(0, 8).forEach(function(p) {
      /* perf batch 3: 44px box (sections/header.liquid:53) — sized, was the raw suggest URL */
      var img = p.image ? '<img' + swImgAttrs(p.image, { src: 140, slot: 44 }) + ' alt="' + escapeHtml(p.title) + '" loading="lazy">' : '';
      html += '<a href="' + p.url + '" class="search-overlay__item" role="option">' +
        '<div class="search-overlay__item-img">' + img + '</div>' +
        '<div class="search-overlay__item-body">' +
        '<p class="search-overlay__item-title">' + escapeHtml(p.title) + '</p>' +
        (p.vendor ? '<p class="search-overlay__item-vendor">' + escapeHtml(p.vendor) + '</p>' : '') +
        '</div>' +
        (p.price ? '<div class="search-overlay__item-price">' + fmtSuggestPrice(p.price) + '</div>' : '') +
        '</a>';
    });
    list.innerHTML = html;
    footer.innerHTML = 'Press <strong>Enter</strong> to see all results for "<a href="/search?q=' + encodeURIComponent(q) + '">' + escapeHtml(q) + '</a>"';
    resultsPanel.hidden = false;
  }

  function renderEmpty(q) {
    list.innerHTML = '<div class="search-overlay__empty">No results for "' + escapeHtml(q) + '"</div>';
    footer.innerHTML = 'Try different keywords or <a href="/collections/all">browse all products</a>';
    resultsPanel.hidden = false;
  }

  function escapeHtml(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  function doSearch(q) {
    if (!q || q.length < 2) { resultsPanel.hidden = true; list.innerHTML = ''; return; }
    if (q === lastQ) return;
    lastQ = q;
    var url = '/search/suggest.json?q=' + encodeURIComponent(q) +
      '&resources[type]=product,collection' +
      '&resources[limit]=8' +
      '&resources[options][unavailable_products]=last' +
      '&resources[options][fields]=title,product_type,variants.title,vendor,body';
    fetch(url, { headers: { 'Accept': 'application/json' } })
      .then(function(r) { return r.json(); })
      .then(function(data) { renderResults(data, q); })
      .catch(function() { renderEmpty(q); });
  }

  if (input) {
    input.addEventListener('input', function() {
      var q = input.value.trim();
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(function() { doSearch(q); }, 220);
    });
  }

  /* Enter key in input: submit form to /search page (natural form behavior) */
  /* Arrow keys navigate results, Enter goes to focused item */
  overlay.addEventListener('keydown', function(e) {
    var items = list.querySelectorAll('.search-overlay__item');
    if (!items.length) return;
    var active = list.querySelector('.is-active');
    var idx = Array.prototype.indexOf.call(items, active);
    if (e.key === 'ArrowDown') {
      e.preventDefault();
      if (active) active.classList.remove('is-active');
      items[Math.min(idx + 1, items.length - 1) || 0].classList.add('is-active');
    } else if (e.key === 'ArrowUp') {
      e.preventDefault();
      if (active) active.classList.remove('is-active');
      items[Math.max(idx - 1, 0)].classList.add('is-active');
    } else if (e.key === 'Enter' && active) {
      e.preventDefault();
      window.location.href = active.getAttribute('href');
    }
  });
})();

/* === Product Variant Switching === */
(function() {
  var form = document.querySelector('form[action*="/cart/add"]');
  if (!form || !window.location.pathname.includes('/products/')) return;

  var radios = form.querySelectorAll('.product-variants__radio');
  var priceEl = document.querySelector('.product-info__price-current');
  var compareEl = document.querySelector('.product-info__price-compare');
  var idInput = form.querySelector('input[name="id"]');
  var atcBtn = form.querySelector('.product-form__atc');
  var mainImg = document.getElementById('main-product-img');

  var productJson = null;
  var jsonEl = document.getElementById('product-json');
  if (jsonEl) { try { productJson = JSON.parse(jsonEl.textContent); } catch(e) {} }

  /* Server-rendered price map ({{ v.price | money }}) — exact parity with the
     on-load PDP price. Primary source for variant-switch prices. */
  var priceMap = null;
  var mapEl = document.getElementById('variant-price-map');
  if (mapEl) { try { priceMap = JSON.parse(mapEl.textContent); } catch(e) {} }

  /* Capture the Liquid-rendered button labels so variant switching keeps the
     localized text instead of hardcoding English. */
  var atcLabelAvailable = atcBtn ? (atcBtn.getAttribute('data-label-available') || (atcBtn.textContent || '').trim() || 'Add to Cart') : '';
  var atcLabelSoldOut   = atcBtn ? (atcBtn.getAttribute('data-label-soldout')   || 'Sold Out') : '';

  if (!productJson || !radios.length) return;

  function getSelectedOptions() {
    var opts = [];
    form.querySelectorAll('fieldset').forEach(function(fs) {
      var checked = fs.querySelector('.product-variants__radio:checked');
      if (checked) opts.push(checked.value);
    });
    return opts;
  }

  function findVariant(opts) {
    return productJson.variants.find(function(v) {
      return v.options.every(function(o, i) { return o === opts[i]; });
    });
  }

  /* money-sweep 2026-09-05: ONE formatter (assets/money.js). Currency from window.SWMarket / cart.currency,
     decimals per currency (KWD/BHD/OMR = 3), format calibrated from Liquid's own money filter. Shopify cents = price × 100. */
  function formatMoney(cents) {
    return window.SWMoney ? window.SWMoney.formatMoney(cents) : (cents / 100).toFixed(2);
  }

  radios.forEach(function(radio) {
    radio.addEventListener('change', function() {
      var opts = getSelectedOptions();
      var variant = findVariant(opts);
      if (!variant) return;

      if (idInput) idInput.value = variant.id;

      var mapped = priceMap && priceMap[variant.id];
      var priceStr = mapped ? mapped.price : formatMoney(variant.price);
      if (priceEl) priceEl.textContent = priceStr;
      /* money-sweep: BNPL snippets read the integer, not the localized text; Arabic mirror follows the currency. */
      if (priceEl) priceEl.setAttribute('data-price-cents', variant.price);
      var arPriceEl = document.querySelector('[data-price-arabic]');
      if (arPriceEl && window.SWMoney) arPriceEl.textContent = ' · ' + window.SWMoney.formatMoneyArabic(variant.price);
      var stickyPriceEl = document.querySelector('.product-sticky-bar__price');
      if (stickyPriceEl) stickyPriceEl.textContent = priceStr;
      if (compareEl) {
        var hasCompare = variant.compare_at_price && variant.compare_at_price > variant.price;
        if (hasCompare) {
          compareEl.textContent = (mapped && mapped.compare_at) ? mapped.compare_at : formatMoney(variant.compare_at_price);
          compareEl.style.display = '';
        } else {
          compareEl.style.display = 'none';
        }
      }

      if (mainImg && variant.featured_image) {
        mainImg.src = variant.featured_image.src;
      }

      if (atcBtn) {
        atcBtn.disabled = !variant.available;
        atcBtn.textContent = variant.available ? atcLabelAvailable : atcLabelSoldOut;
      }
    });
  });
})();

/* === AJAX Collection Switching — prefetch + in-memory cache for instant swaps === */
(function() {
  var nav = document.querySelector('[data-collection-nav]');
  var content = document.querySelector('[data-collection-content]');
  if (!nav || !content) return;

  var loading = false;
  var cache = Object.create(null);   /* url -> { html, title } */
  var inflight = Object.create(null); /* url -> Promise */

  function normalize(url) {
    try { return new URL(url, window.location.origin).pathname + new URL(url, window.location.origin).search; }
    catch (e) { return url; }
  }

  function setActive(url) {
    var u = normalize(url);
    nav.querySelectorAll('.collection-nav__card').forEach(function(card) {
      var href = card.getAttribute('href');
      var match = href && u.indexOf(normalize(href)) === 0;
      card.classList.toggle('collection-nav__card--active', !!match);
    });
  }

  /* fetch with a hard timeout — a stalled connection must never be able to
     freeze collection navigation forever (the "it locks itself" symptom). */
  function timedFetch(url, ms) {
    var ctrl = (typeof AbortController !== 'undefined') ? new AbortController() : null;
    var opts = { headers: { 'Accept': 'text/html' }, credentials: 'same-origin' };
    if (ctrl) opts.signal = ctrl.signal;
    var timer = setTimeout(function() { if (ctrl) ctrl.abort(); }, ms || 12000);
    return fetch(url, opts).then(
      function(r) { clearTimeout(timer); return r; },
      function(e) { clearTimeout(timer); throw e; }
    );
  }

  function fetchInto(url) {
    var key = normalize(url);
    if (cache[key]) return Promise.resolve(cache[key]);
    if (inflight[key]) return inflight[key];
    inflight[key] = timedFetch(url, 12000)
      .then(function(r) { return r.text(); })
      .then(function(html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-collection-content]');
        var entry = {
          html: fresh ? fresh.innerHTML : null,
          title: doc.title || document.title
        };
        if (entry.html) cache[key] = entry;
        delete inflight[key];
        return entry;
      })
      .catch(function(err) {
        delete inflight[key];
        throw err;
      });
    return inflight[key];
  }

  function render(entry, url, push) {
    if (!entry || !entry.html) { window.location.href = url; return; }
    content.innerHTML = entry.html;
    document.title = entry.title;
    if (push) window.history.pushState({ collectionUrl: url }, '', url);
    setActive(url);
    var navTop = nav.getBoundingClientRect().top + window.scrollY - 80;
    if (window.scrollY > navTop) window.scrollTo({ top: navTop, behavior: 'smooth' });
  }

  var loadWatchdog = null;
  function clearLoad() {
    if (loadWatchdog) { clearTimeout(loadWatchdog); loadWatchdog = null; }
    content.style.opacity = '';
    content.style.pointerEvents = '';
    loading = false;
  }

  function swap(url, push) {
    if (loading) return;
    var key = normalize(url);
    if (cache[key]) {
      /* Instant render from cache */
      render(cache[key], url, push);
      return;
    }
    loading = true;
    content.style.opacity = '0.6';
    content.style.pointerEvents = 'none';
    /* Backstop: if anything stalls, never leave the grid locked — hard-navigate. */
    loadWatchdog = setTimeout(function() {
      if (loading) { loadWatchdog = null; window.location.href = url; }
    }, 15000);
    fetchInto(url)
      .then(function(entry) { render(entry, url, push); })
      .catch(function() { window.location.href = url; })
      .then(clearLoad);
  }

  /* Prefetch the current collection into cache so back/forward are instant */
  (function seedCurrent() {
    var curr = window.location.pathname + window.location.search;
    cache[normalize(curr)] = { html: content.innerHTML, title: document.title };
  })();

  /* Prefetch nav collections in the background (idle + sequentially).
     Throttled: skip entirely on Save-Data / slow connections, and cap the
     number of background prefetches so we never saturate the connection on
     page load (the "takes forever to reload" symptom). Hover/touch prefetch
     below still covers any collection the user actually heads toward. */
  var PREFETCH_CAP = 6;
  function connectionTooSlow() {
    var c = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
    if (!c) return false;
    if (c.saveData) return true;
    if (c.effectiveType && /(^|\b)(slow-2g|2g|3g)\b/.test(c.effectiveType)) return true;
    return false;
  }
  function idlePrefetchAll() {
    if (connectionTooSlow()) return;
    var links = [];
    nav.querySelectorAll('.collection-nav__card').forEach(function(a) {
      var href = a.getAttribute('href');
      if (href && !cache[normalize(href)]) links.push(href);
    });
    var queue = links.slice(0, PREFETCH_CAP);
    function next() {
      if (!queue.length) return;
      var url = queue.shift();
      fetchInto(url).then(function() {
        if (window.requestIdleCallback) requestIdleCallback(next, { timeout: 1500 });
        else setTimeout(next, 400);
      }).catch(next);
    }
    if (window.requestIdleCallback) requestIdleCallback(next, { timeout: 2000 });
    else setTimeout(next, 800);
  }
  idlePrefetchAll();

  /* Hover / touchstart prefetch for near-instant feel */
  nav.addEventListener('mouseover', function(e) {
    var card = e.target.closest('.collection-nav__card');
    if (!card) return;
    var href = card.getAttribute('href');
    if (href) fetchInto(href).catch(function(){});
  });
  nav.addEventListener('touchstart', function(e) {
    var card = e.target.closest('.collection-nav__card');
    if (!card) return;
    var href = card.getAttribute('href');
    if (href) fetchInto(href).catch(function(){});
  }, { passive: true });

  /* Intercept clicks on nav cards */
  nav.addEventListener('click', function(e) {
    var card = e.target.closest('.collection-nav__card');
    if (!card) return;
    var href = card.getAttribute('href');
    if (!href) return;
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.button === 1) return;
    e.preventDefault();
    swap(href, true);
  });

  /* Intercept pagination + sort select inside the content area */
  content.addEventListener('click', function(e) {
    var link = e.target.closest('.coll-pagination a');
    if (!link) return;
    if (e.metaKey || e.ctrlKey || e.shiftKey) return;
    e.preventDefault();
    swap(link.getAttribute('href'), true);
  });

  content.addEventListener('change', function(e) {
    if (e.target && e.target.id === 'sort-select') {
      swap(e.target.value, true);
    }
  });

  /* Back / forward */
  window.addEventListener('popstate', function() {
    swap(window.location.href, false);
  });
})();

/* === SafeWake Product Page Recommendation Engine ===
   Powers: Complete Your Setup (smart cross-sell), You May Also Like
   (infinite scroll + variety), Frequently Bought Together (mini-bundle). */
(function() {
  function norm(s) { return (s || '').toString().toLowerCase(); }

  /* ============================================================
     TAXONOMY v2 (2026-07-04) — canonical-type-first categorize.
     The catalog now publishes vault.db canonical snake_case types
     (wakeboard / system_binding / rope_surf / binding_accessory …)
     but this engine was still fuzzy-matching the OLD human-readable
     types — that's why System Boots pages showed nothing, surf ropes
     recommended wakeboards, and screw kits landed next to boards.
     Exact-match the canonical types FIRST; legacy fuzzy matching
     stays as a fallback for any product not yet migrated.
     Sport islands: wake+boat / ski / snow — never cross-pollinate.
     ============================================================ */
  var CANON = {
    wakeboard:              'wake_board',
    binding:                'wake_binding',
    system_binding:         'system_binding',
    system_boots:           'system_boot',
    wakesurfer:             'wake_surf',
    wakesurfer_accessory:   'surf_accessory',
    rope_wake:              'wake_rope',
    rope_surf:              'surf_rope',
    rope_tube:              'tube_rope',
    rope_ski:               'ski_rope',
    rope_foil:              'surf_rope',
    tube:                   'wake_tube',
    life_jacket:            'wake_vest',
    ncga_vest:              'wake_vest',
    wakeboard_accessory:    'wake_accessory',
    binding_accessory:      'hardware',
    hardware:               'hardware',
    wake_glove:             'glove',
    waterski:               'waterski',
    waterski_boot:          'ski_boot',
    waterski_boot_accessory:'ski_accessory',
    waterski_accessory:     'ski_accessory',
    barefoot:               'waterski',
    kneeboard:              'kneeboard',
    kneeboard_accessory:    'wake_accessory',
    foil:                   'wake_foil',
    paddleboard:            'paddleboard',
    ballast:                'ballast',
    tower_pylon:            'tower',
    marine:                 'marine',
    helmet:                 'helmet',
    snowboard:              'snowboard',
    snowboard_binding:      'snow_binding',
    snowboard_boot:         'snow_boot',
    snowboard_accessory:    'snow_accessory',
    leisure:                'leisure',
    kayak:                  'leisure'
  };

  /* Rescue map for products with a BLANK product_type (locally-created /
     donor products, e.g. most of UAE's flagship boards). Generated from
     vault.db canonical types on 2026-07-04 — consulted only when the type
     field gives us nothing. Values are CANON keys. */
  var SW_TITLE_SEED = {"coastal wmn tank":"apparel","codyak pair":"system_boots","costco hl paddle":"life_jacket","costco trident 3":"tube","crypticbwf":"wakeboard","cw 3.9 gromcast":"wakesurfer","cw 4.8 hl broadcast":"wakesurfer","daytona crew":"apparel","destroyer coach":"apparel","dino":"tube","divine":"wakeboard","divine jr":"wakeboard","dockside sweatpant":"apparel","dog":"tube","dorado isup":"paddleboard","droid 3 set w/key":"wakesurfer","eden bwf":"wakeboard","electron kb w/powerlock strap":"kneeboard","factory coach":"apparel","feather flag kit":"accessory","flamingo":"tube","footbed":"waterski_boot_accessory","forever wmn crew":"apparel","fusion plate hardware kit":"binding_accessory","future cheetah omni":"waterski","glide":"tube","good daze wmn tee":"apparel","gooey pair":"system_boots","gripper":"bag","guara":"wakeboard","hawaii big atoll":"tube","hawaii little atoll":"tube","hawaii tritoon":"tube","hot shot hs heel pl3":"waterski_boot_accessory","hot shot hs toe pl3":"waterski_boot_accessory","ishade tent":"tube","jinx":"binding","jinx junior":"binding","jinx pair junior":"binding","laguna":"tube","lay-z lounge":"tube","lounge mat":"tube","m60":"binding","men's salsa lace":"snowboard_boot","mens":"life_jacket"};

  /* Tag-based category rescue — blank-type products carry category tags
     ('binding', 'inflatable', 'gooey-boot' …). Ordered most-specific-first. */
  var TAG_RULES = [
    ['gooey-boot',        'system_boot'],
    ['binding accessory', 'hardware'],
    ['snowboard boot',    'snow_boot'],
    ['snow-boot',         'snow_boot'],
    ['snowboard',         'snowboard'],
    ['binding',           'wake_binding'],
    ['wakeboard',         'wake_board'],
    ['wakesurfer',        'wake_surf'],
    ['inflatable',        'wake_tube'],
    ['tube',              'wake_tube'],
    ['life jacket',       'wake_vest'],
    ['vest',              'wake_vest'],
    ['waterski',          'waterski'],
    ['kneeboard',         'kneeboard'],
    ['helmet',            'helmet'],
    ['foil',              'wake_foil'],
    ['ballast',           'ballast'],
    ['gloves',            'glove'],
    ['apparel',           'apparel'],
    ['accessory',         'wake_accessory']
  ];

  function categorize(p) {
    if (!p) return null;
    var v = norm(p.vendor).replace(/^\d{4}\s*/, '');
    var rawT = norm(p.product_type || p.type).replace(/^\d{4}\s*/, '').trim();
    /* normalize legacy display types too: "Rope - Ski" → "rope_ski" */
    var t = rawT.replace(/[\s\-]+/g, '_').replace(/_+/g, '_');
    var title = norm(p.title);
    var snowVendor = /bataleon|rome/.test(v);

    /* --- 0. spare-part guard: runs BEFORE the type field is trusted.
       The same screw kit is typed system_binding on one store and hardware
       on another (store-data drift) — title is the only stable signal.
       hardware is never recommended anywhere, so this permanently kills
       "a bunch of screws next to a wakeboard". --- */
    if (/hardware kit|hardware$|screw|lace set|lace loop|lace lock|lace end|washer|adjust nut|chassis|footbed|wedge kit|(ankle|toe).*strap|ladder strap|ratchet/.test(title)) {
      return 'hardware';
    }

    /* --- 1. canonical vault types (exact match) --- */
    if (CANON.hasOwnProperty(t)) {
      /* snow vendors keep their island even on shared generic types */
      if (!snowVendor || t.indexOf('snow') === 0) return CANON[t];
    }

    /* --- 1b. blank-type rescue: category tags, then the vault title seed --- */
    if (!t) {
      var tagBlob = ',' + norm(Array.isArray(p.tags) ? p.tags.join(',') : (p.tags || '')) + ',';
      for (var r = 0; r < TAG_RULES.length; r++) {
        if (tagBlob.indexOf(TAG_RULES[r][0]) !== -1) {
          if (snowVendor && TAG_RULES[r][1].indexOf('snow') !== 0) break; /* snow island guard */
          return TAG_RULES[r][1];
        }
      }
      var seeded = SW_TITLE_SEED[title.trim()];
      if (seeded && CANON.hasOwnProperty(seeded)) return CANON[seeded];
      /* last resort: sniff obvious words out of the title */
      if (/tube rope|safety tube/.test(title)) return 'tube_rope';
      if (/rope|handle|mainline/.test(title))  return /surf/.test(title) ? 'surf_rope' : 'wake_rope';
      if (/vest|jacket|pfd/.test(title))       return 'wake_vest';
      if (/hardware|screw|lace|plate|footbed|wedge/.test(title)) return 'hardware';
    }

    /* --- 2. sport island detection for generic/legacy types --- */
    var sport = snowVendor            ? 'snow'
              : /hyperlite/.test(v)   ? 'wake'
              : /ho\s*sports/.test(v) ? 'ski'
              : /sandbox/.test(v)     ? 'helmet'
              : /heyday/.test(v)      ? 'boat' : '';
    if (!sport) {
      if (/snow/.test(t))                                        sport = 'snow';
      else if (/wake|foil|tube|surf|ballast|tower|marine/.test(t)) sport = 'wake';
      else if (/ski|barefoot/.test(t))                           sport = 'ski';
    }

    /* --- 3. generic types that need title context --- */
    if (/bag/.test(t)) {
      if (sport === 'snow')          return 'snow_bag';
      if (/surf|sock/.test(title))   return 'surf_bag';   /* HO makes surf gear too — check before ski */
      if (sport === 'ski')           return 'ski_bag';
      if (/board/.test(title) || sport === 'wake') return 'board_bag';
      return 'gear_bag';
    }
    if (/rope/.test(t)) {
      if (/surf/.test(title))          return 'surf_rope';
      if (/tube|tow(?!er)/.test(title)) return 'tube_rope';
      if (/ski|slalom|deep/.test(title)) return 'ski_rope';
      if (sport === 'ski')             return 'ski_rope';
      return 'wake_rope';
    }
    if (/accessor/.test(t)) {
      if (sport === 'snow')        return 'snow_accessory';
      if (/surf/.test(title))      return 'surf_accessory';
      if (sport === 'ski')         return 'ski_accessory';
      return 'wake_accessory';
    }
    if (/apparel|boardshort|rash|tee|hoodie/.test(t)) {
      return sport === 'snow' ? 'snow_apparel' : 'apparel';
    }
    if (/vest|pfd|jacket|comp/.test(t))                 return 'wake_vest';
    if (/helmet/.test(t) || sport === 'helmet' || /helmet/.test(title)) return 'helmet';

    /* --- 4. legacy fuzzy fallback per island --- */
    if (sport === 'snow') {
      if (/boot/.test(t))    return 'snow_boot';
      if (/binding/.test(t)) return 'snow_binding';
      return 'snowboard';
    }
    if (sport === 'ski') {
      if (/glove|wetsuit|westuit/.test(t)) return 'glove';
      if (/boot|binding/.test(t))          return 'ski_boot';
      if (/ski|barefoot/.test(t))          return 'waterski';
      return 'ski_other';
    }
    if (sport === 'wake' || sport === 'boat') {
      if (/system/.test(t) && /boot/.test(t)) return 'system_boot';
      if (/system/.test(t))                   return 'system_binding';
      if (/binding|boot/.test(t))             return 'wake_binding';
      if (/glove/.test(t))                    return 'glove';
      if (/knee/.test(t))                     return 'kneeboard';
      if (/surf/.test(t))                     return 'wake_surf';
      if (/tube|towable/.test(t))             return 'wake_tube';
      if (/foil/.test(t))                     return 'wake_foil';
      if (/paddle/.test(t))                   return 'paddleboard';
      if (/ballast/.test(t))                  return 'ballast';
      if (/tower|pylon/.test(t))              return 'tower';
      if (/marine|boat/.test(t))              return 'marine';
      if (/wake|board|cable/.test(t))         return 'wake_board';
      return 'wake_other';
    }
    return null;
  }

  /* Cross-sell map v2 — founder-spec complementary pairings (2026-07-04).
     Rules:
       1. Same-sport islands only (wake/ski/snow never cross; vests are the
          one deliberate water-sports crossover)
       2. Every category points to complementary items — never itself
       3. Order = FBT priority: first two stocked categories become the bundle
       4. System chassis ↔ System boots are a hard pair — each leads with the other
       5. Ropes point back to what they pull: surf rope → wakesurfer,
          tube rope → towable, wake rope → wakeboard
       6. Bags point to what goes inside them
       7. hardware (screw kits, laces, chassis spares) is NEVER recommended —
          it only points upward to bindings/boards from its own page */
  var CROSS_SELL = {
    /* WAKE — boat + cable ecosystem */
    wake_board:     ['wake_binding', 'wake_rope', 'wake_vest', 'board_bag', 'helmet', 'apparel'],
    wake_binding:   ['wake_board', 'wake_vest', 'wake_rope', 'board_bag'],
    system_binding: ['system_boot', 'wake_board', 'wake_vest', 'helmet'],
    system_boot:    ['system_binding', 'wake_board', 'wake_vest', 'helmet'],
    wake_rope:      ['wake_board', 'wake_binding', 'wake_vest', 'glove'],
    board_bag:      ['wake_board', 'wake_binding', 'wake_rope'],
    wake_surf:      ['surf_rope', 'wake_vest', 'surf_bag', 'ballast', 'surf_accessory'],
    surf_rope:      ['wake_surf', 'wake_vest', 'surf_bag'],
    surf_bag:       ['wake_surf', 'surf_rope', 'wake_vest'],
    surf_accessory: ['wake_surf', 'surf_rope', 'wake_vest'],
    wake_tube:      ['tube_rope', 'wake_vest', 'marine'],
    tube_rope:      ['wake_tube', 'wake_vest', 'marine'],
    wake_vest:      ['wake_board', 'wake_surf', 'wake_tube', 'waterski'],
    wake_foil:      ['wake_vest', 'surf_rope', 'board_bag'],
    kneeboard:      ['wake_rope', 'wake_vest', 'wake_tube'],
    glove:          ['wake_rope', 'ski_rope', 'wake_vest'],
    helmet:         ['wake_board', 'system_binding', 'wake_binding', 'wake_vest'],
    hardware:       ['wake_binding', 'system_binding', 'wake_board'],
    wake_accessory: ['wake_board', 'wake_binding', 'wake_vest'],
    apparel:        ['wake_vest', 'wake_board', 'wake_surf'],
    gear_bag:       ['wake_board', 'wake_surf', 'wake_vest'],
    paddleboard:    ['wake_vest', 'wake_accessory', 'gear_bag'],
    ballast:        ['wake_surf', 'marine', 'tower'],
    tower:          ['marine', 'ballast', 'wake_rope'],
    marine:         ['ballast', 'tower', 'wake_tube'],
    leisure:        ['wake_vest', 'wake_tube', 'marine'],
    wake_other:     ['wake_vest', 'wake_board', 'wake_accessory'],
    ski_other:      ['waterski', 'wake_vest', 'ski_rope'],
    /* SKI ecosystem */
    waterski:       ['ski_boot', 'wake_vest', 'ski_rope', 'glove', 'ski_bag'],
    ski_boot:       ['waterski', 'wake_vest', 'ski_rope', 'glove'],
    ski_rope:       ['waterski', 'ski_boot', 'glove', 'wake_vest'],
    ski_bag:        ['waterski', 'ski_boot'],
    ski_accessory:  ['waterski', 'ski_boot', 'ski_rope'],
    /* SNOW island — never crosses into water sports */
    snowboard:      ['snow_binding', 'snow_boot', 'snow_bag', 'snow_apparel'],
    snow_binding:   ['snowboard', 'snow_boot', 'snow_bag'],
    snow_boot:      ['snowboard', 'snow_binding', 'snow_bag'],
    snow_bag:       ['snowboard', 'snow_binding'],
    snow_accessory: ['snowboard', 'snow_binding'],
    snow_apparel:   ['snowboard', 'snow_binding']
  };

  /* Cable-park boards ride with System chassis + boots, not boat bindings.
     When a wakeboard is cable-tagged (Guara, Motive, park boards…), lead the
     recommendation with the full System pairing + protection. */
  function getWantedCats(p, cat) {
    if (cat === 'wake_board' && p) {
      var tagStr = norm(Array.isArray(p.tags) ? p.tags.join(',') : (p.tags || ''));
      var blob = tagStr + ' ' + norm(p.title);
      if (/cable|\bpark\b/.test(blob)) {
        return ['system_binding', 'system_boot', 'wake_vest', 'helmet', 'wake_binding', 'board_bag'];
      }
    }
    return CROSS_SELL[cat] || [];
  }

  /* Shared engine handle — the cart-page IIFE consumes this instead of
     keeping its own drifted duplicate of the taxonomy. */
  window.SWRecEngine = { categorize: categorize, CROSS_SELL: CROSS_SELL, getWantedCats: getWantedCats };

  /* Filter: in-stock AND priced > 0. Handles BOTH /products.json format
     (price inside variants[]) AND Ajax API format (top-level price_min).
     Blocks the ~70% zero-priced catalog rows from every carousel. */
  function isShowable(p) {
    if (!p) return false;
    /* /products.json shape: variants[] each with { price: "179.66", available: true } */
    if (p.variants && p.variants.length) {
      return p.variants.some(function(v) {
        if (v.available === false) return false;
        var price = parseFloat(v.price);
        return isFinite(price) && price > 0;
      });
    }
    /* Ajax API / recommendations API shape: top-level price_min + available */
    if (p.available === false) return false;
    var price = (p.price_min != null ? p.price_min : p.price);
    var num = typeof price === 'number' ? price
            : typeof price === 'string' ? parseFloat(price) : NaN;
    if (!isFinite(num) || num <= 0) return false;
    return true;
  }

  /* Back-compat shim — old call sites still pass (type, tags) without vendor.
     Only used as a fallback if a caller lacks product vendor info. */
  function detectCategory(type, tags, vendor) {
    return categorize({ product_type: type, tags: tags || [], vendor: vendor || '' });
  }

  /* Global store cache — avoid refetching /products.json on same page */
  var storeCache = { products: [], exhaustedPage: null, loadedPages: {} };

  function fetchStorePage(page) {
    if (storeCache.loadedPages[page]) return Promise.resolve([]);
    storeCache.loadedPages[page] = true;
    return fetch(swFresh('/products.json?limit=50&page=' + page + '&sort_by=best-selling'), { headers: { 'Accept': 'application/json' } })
      .then(function(r) { return r.json(); })
      .then(function(data) {
        var arr = (data && data.products) || [];
        if (!arr.length) storeCache.exhaustedPage = page;
        /* Drop zero-price + sold-out at the source so every downstream carousel is clean */
        var filtered = arr.filter(isShowable);
        storeCache.products = storeCache.products.concat(filtered);
        return filtered;
      })
      .catch(function() { storeCache.exhaustedPage = page; return []; });
  }

  /* Shared horizontal infinite scroller. `loader` returns a Promise resolving to `true` when exhausted. */
  function makeInfiniteScroller(container, loader, opts) {
    opts = opts || {};
    var prefetch = opts.prefetch != null ? opts.prefetch : 300;
    var loading = false, done = false;
    function tick() {
      if (loading || done) return;
      if (container.scrollLeft + container.clientWidth > container.scrollWidth - prefetch) {
        loading = true;
        Promise.resolve(loader()).then(function(exhausted) {
          loading = false;
          if (exhausted) done = true;
        }).catch(function() { loading = false; });
      }
    }
    container.addEventListener('scroll', tick, { passive: true });
    setTimeout(tick, 120);
    return { refresh: tick };
  }

  function formatPriceCents(cents) {
    /* money-sweep: Shopify cents (× 100, every currency) → market-currency display via assets/money.js */
    return window.SWMoney ? window.SWMoney.formatMoney(cents) : (cents / 100).toFixed(2);
  }

  /* perf batch 3: extraction ONLY — the fallback chain is unchanged, but the URL is
     returned RAW and sized at each call site through swImgAttrs(), which knows the
     width that card is actually rendered at. The old inline sizing here was skipped
     entirely for the protocol-relative URLs /recommendations/products.json returns,
     which is why recommendation cards were pulling original-size files. */
  function extractImage(p) {
    var img = p.featured_image || (p.images && p.images[0]) || (p.image && p.image.src) || '';
    if (img && typeof img === 'object') img = img.src;
    return img || '';
  }

  function escAttr(s) { return String(s == null ? '' : s).replace(/"/g, '&quot;'); }
  function escHtml(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function(c) {
    return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c];
  }); }

  function priceText(p) {
    /* Derive price from the first available variant for /products.json shape,
       then fall back to top-level for Ajax/recs API. Without this, wakeboard
       cards fetched from /products.json would all display as "0.000 AED".
       P29 FIX: removed the cents>1000 branch — priceText is ONLY called on
       /products.json products which are ALWAYS decimal, never cents. The old
       heuristic broke on prices between 10-999 KWD. */
    var priceVal = null;
    if (p.variants && p.variants.length) {
      for (var i = 0; i < p.variants.length; i++) {
        var v = p.variants[i];
        if (v && v.available !== false && v.price != null) { priceVal = v.price; break; }
      }
      if (priceVal == null && p.variants[0] != null) priceVal = p.variants[0].price;
    }
    if (priceVal == null) priceVal = (p.price != null ? p.price : p.price_min);
    if (typeof priceVal === 'string' && /[A-Z]/.test(priceVal)) return priceVal;
    var num = parseFloat(priceVal);
    if (isNaN(num) || num <= 0) return '';
    /* money-sweep: /products.json prices are DECIMAL strings ("21.900") → cents → market-currency display */
    return window.SWMoney ? window.SWMoney.formatMoney(window.SWMoney.fromDecimal(num)) : num.toFixed(2);
  }

  function recCardHtml(p) {
    var url = p.url || ('/products/' + p.handle);
    var img = extractImage(p);
    var imgHtml = img
      /* perf batch 3: .rec-card is 160px (measured, 1440 + 390); src stays 400 = the
         width main-product.liquid:779 uses for the server-rendered twin of this card */
      ? '<img' + swImgAttrs(img, { src: 400, slot: 160 }) + ' alt="' + escAttr(p.title) + '" loading="lazy" style="width:100%;height:100%;object-fit:contain;padding:8px;">'
      : '';
    var tagsStr = (p.tags || []).map(norm).join(',');
    var express = tagsStr.indexOf('locally stored') >= 0
      ? ''
      : '';
    var type = escAttr(p.product_type || p.type || '');
    return '<a href="' + escAttr(url) + '" class="rec-card" data-rec-type="' + type + '" style="flex-shrink:0;width:160px;text-decoration:none;color:inherit;">' +
      '<div class="rec-card__img" style="aspect-ratio:1;border-radius:12px;overflow:hidden;background:transparent;position:relative;">' +
      imgHtml + express + '</div>' +
      '<p style="font-size:0.6875rem;color:rgb(var(--color-muted));margin:6px 0 2px;">' + escHtml(p.vendor || '') + '</p>' +
      '<p style="font-size:0.8125rem;font-weight:500;margin:0 0 4px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;">' + escHtml(p.title) + '</p>' +
      '<p class="rec-card__price" style="font-size:0.8125rem;margin:0;">' + escHtml(priceText(p)) + '</p>' +
      '</a>';
  }

  function bundleCardHtml(p) {
    var url = p.url || ('/products/' + p.handle);
    var img = extractImage(p);
    var imgHtml = img
      /* perf batch 3: .bundle-card__img renders 160px (measured); width/height attrs
         kept at the existing 140 — same 1:1 ratio, so nothing in the layout moves */
      ? '<img' + swImgAttrs(img, { src: 400, slot: 160, w: 140, h: 140 }) + ' alt="' + escAttr(p.title) + '" loading="lazy">'
      : '';
    var variantId = p.variants && p.variants[0] && p.variants[0].id;
    var available = p.available !== false && variantId;
    var soldoutTxt = 'Sold out';
    var addPrefix = 'Add';
    var priceFull = priceText(p);
    var priceShort = (priceFull && window.SWMoney) ? window.SWMoney.formatMoney(window.SWMoney.parse(priceFull)) : priceFull; /* money-sweep: keep the currency token (was formatAmount = bare number) so price-dual can convert the button — 2026-09-06 */
    var addBtn = available
      ? '<form action="/cart/add" method="post" class="bundle-card__form">' +
        '<input type="hidden" name="id" value="' + variantId + '">' +
        '<button type="submit" class="bundle-card__add" aria-label="Add to cart">' +
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>' +
        '<span data-i18n="products.bundle.add_prefix">' + escHtml(addPrefix) + '</span> · ' + escHtml(priceShort) + '</button></form>'
      : '<span class="bundle-card__soldout" data-i18n="products.sold_out">' + escHtml(soldoutTxt) + '</span>';
    return '<div class="bundle-card">' +
      '<a href="' + escAttr(url) + '" class="bundle-card__link">' +
      '<div class="bundle-card__img">' + imgHtml + '</div>' +
      '<p class="bundle-card__vendor">' + escHtml(p.vendor || '') + '</p>' +
      '<p class="bundle-card__title">' + escHtml((p.title || '').substr(0, 30)) + '</p>' +
      '</a>' + addBtn + '</div>';
  }

  /* ===== COMPLETE YOUR SETUP — Smart Cross-Sell + Infinite Scroll ===== */
  (function completeSetup() {
    var section = document.querySelector('[data-complete-setup]');
    if (!section) return;
    var track = section.querySelector('[data-complete-setup-track]');
    if (!track) return;
    var currentHandle = section.getAttribute('data-product-handle');
    var source = {
      handle: currentHandle,
      vendor: section.getAttribute('data-product-vendor') || '',
      product_type: section.getAttribute('data-product-type') || '',
      title: section.getAttribute('data-product-title') || '',
      tags: (section.getAttribute('data-product-tags') || '').split(',').map(function(s){ return s.trim(); }).filter(Boolean)
    };
    var srcCat = categorize(source);
    if (!srcCat) return;
    var wantedCats = getWantedCats(source, srcCat);
    if (!wantedCats.length) return;
    var wantedSet = {}; wantedCats.forEach(function(c) { wantedSet[c] = true; });

    var shown = {};
    shown[currentHandle] = true;
    var lastCat = null, sameRun = 0;
    var page = 1;

    function renderPicks(products) {
      if (!products || !products.length) return 0;
      var appended = 0;
      /* Interleave by category so we don't dump 6 bindings before the first vest */
      var byCat = {};
      products.forEach(function(p) {
        if (!p || !p.handle || shown[p.handle]) return;
        if (!isShowable(p)) return;
        var cat = categorize(p);
        if (!cat || !wantedSet[cat]) return;
        (byCat[cat] = byCat[cat] || []).push(p);
      });
      var cats = Object.keys(byCat);
      if (!cats.length) return 0;
      var maxLen = cats.reduce(function(m, c) { return Math.max(m, byCat[c].length); }, 0);
      var queue = [];
      for (var i = 0; i < maxLen; i++) {
        cats.forEach(function(c) { if (byCat[c][i]) queue.push(byCat[c][i]); });
      }
      queue.forEach(function(p) {
        if (shown[p.handle]) return;
        var cat = categorize(p);
        if (cat === lastCat) {
          sameRun++;
          if (sameRun >= 3) return; /* Variety gate */
        } else {
          sameRun = 0; lastCat = cat;
        }
        track.insertAdjacentHTML('beforeend', bundleCardHtml(p));
        shown[p.handle] = true;
        appended++;
      });
      return appended;
    }

    function loader() {
      /* Try cached products first */
      if (storeCache.products.length) {
        var added = renderPicks(storeCache.products);
        if (added > 0) {
          notifyCardsRendered();
          return Promise.resolve(false);
        }
      }
      /* Fetch next page */
      if (storeCache.exhaustedPage && page > storeCache.exhaustedPage) return Promise.resolve(true);
      return fetchStorePage(page).then(function(arr) {
        page++;
        var added = renderPicks(arr);
        if (added > 0) notifyCardsRendered();
        if (added === 0 && (storeCache.exhaustedPage || arr.length === 0)) return true;
        return false;
      });
    }

    function notifyCardsRendered() {
      window.dispatchEvent(new CustomEvent('sw:cards-rendered', { detail: { scope: track } }));
    }

    /* Init — smart picks only. If smart engine finds 0 complementary products,
       hide the section entirely. We never fall back to same-collection products
       (which on a wakeboard PDP would show more wakeboards — the exact bug the
       founder flagged). */
    fetchStorePage(1).then(function(){ return fetchStorePage(2); }).then(function() {
      var liquidSeedCount = track.children.length;
      renderPicks(storeCache.products);
      var smartCount = track.children.length - liquidSeedCount;
      if (smartCount >= 1) {
        /* Remove Liquid-seeded cards — smart picks now populate */
        for (var i = 0; i < liquidSeedCount; i++) {
          if (track.firstChild) track.removeChild(track.firstChild);
        }
        section.hidden = false; /* P29: reveal after JS populates with complementary products */
        makeInfiniteScroller(track, loader);
      } else {
        /* Smart engine found nothing — hide the whole CYS section rather than
           show misleading same-collection products. */
        section.hidden = true;
      }
    });
  })();

  /* ===== FREQUENTLY BOUGHT TOGETHER ===== */
  (function fbt() {
    var section = document.querySelector('[data-product-fbt]');
    if (!section) return;
    var row = section.querySelector('[data-fbt-row]');
    var totalEl = section.querySelector('[data-fbt-total]');
    var saveEl = section.querySelector('[data-fbt-save]');
    var addAllBtn = section.querySelector('[data-fbt-add-all]');
    var productJsonEl = document.getElementById('product-json');
    if (!row || !productJsonEl) return;

    var current;
    try { current = JSON.parse(productJsonEl.textContent); } catch (e) { return; }
    var srcCat = categorize({
      vendor: current.vendor,
      product_type: current.type || current.product_type,
      title: current.title,
      tags: current.tags
    });
    if (!srcCat) return;
    var wantedCats = getWantedCats(current, srcCat);
    if (!wantedCats.length) return;

    function pick2(products) {
      /* Pick exactly ONE product per wanted category (max 2 total).
         Bug fix: previous version didn't break after first match per category,
         so two "Wake Binding" products (a binding + a system boot both typed
         as Wake Binding) would both get picked — showing binding+boot which
         don't go together. Now each category gets at most 1 pick. */
      var picked = [];
      var seen = {};
      /* Family gate: never bundle two binding-type products together
         (a one-piece binding AND a System chassis). System chassis + System
         boots are different families on purpose — they complete each other. */
      var FAMILY = { wake_binding: 'binding', system_binding: 'binding' };
      var pickedFams = {};
      seen[current.handle] = true;
      for (var i = 0; i < wantedCats.length && picked.length < 2; i++) {
        var cat = wantedCats[i];
        var fam = FAMILY[cat];
        if (fam && pickedFams[fam]) continue;
        for (var j = 0; j < products.length; j++) {
          var p = products[j];
          if (seen[p.handle]) continue;
          if (!isShowable(p)) continue;
          var bv = bestVariant(p);
          if (!bv || toKWD(bv.price, false) <= 0) continue;
          var pcat = categorize(p);
          if (pcat !== cat) continue;
          picked.push(p); seen[p.handle] = true;
          if (fam) pickedFams[fam] = true;
          break; /* ONE per category — move to next wantedCat */
        }
      }
      return picked;
    }

    /* Find the FIRST available non-zero-priced variant for a product.
       Fix: variants[0] is often a zero-price or sold-out variant in this catalog
       (~70% of variants are priced 0). This caused FBT to display "0.000 AED". */
    function bestVariant(prod) {
      if (!prod.variants || !prod.variants.length) return null;
      /* Vests: lead with a common size (M/L) instead of variants[0], which is
         often XS — a bundle nobody wants. Boots/boards keep first-available. */
      if (/life_jacket|ncga_vest|vest|jacket/.test(norm(prod.product_type || prod.type))) {
        for (var s = 0; s < prod.variants.length; s++) {
          var sv = prod.variants[s];
          if (sv.available !== false && parseFloat(sv.price) > 0 &&
              /(^|[\s\/(])(m|l|medium|large)([\s\/)]|$)/.test(norm(sv.title))) return sv;
        }
      }
      for (var i = 0; i < prod.variants.length; i++) {
        var v = prod.variants[i];
        if (v.available !== false && parseFloat(v.price) > 0) return v;
      }
      for (var j = 0; j < prod.variants.length; j++) {
        if (parseFloat(prod.variants[j].price) > 0) return prod.variants[j];
      }
      return prod.variants[0];
    }

    /* Normalize a variant price to KWD decimal — SOURCE-AWARE (P29 fix).
       - fromLiquid=true  → price is from Liquid JSON ({{ product | json }}) = integer cents → ALWAYS ÷100
       - fromLiquid=false → price is from /products.json Ajax = decimal string → NEVER ÷100
       The old >999 heuristic broke on cheap items (9.99 KWD = 999 cents → treated as decimal). */
    function toKWD(rawPrice, fromLiquid) {
      /* money-sweep: name kept for call sites; returns DECIMAL units in the MARKET currency (not only KWD).
         Liquid JSON = Shopify cents (× 100 for every currency) → assets/money.js; /products.json = decimal already. */
      if (rawPrice == null) return 0;
      var n = parseFloat(rawPrice);
      if (!isFinite(n)) return 0;
      return fromLiquid ? (window.SWMoney ? window.SWMoney.toDecimal(n) : n / 100) : n;
    }

    function fbtItemHtml(p, checked, isCurrent) {
      var img = extractImage(p);
      var imgHtml = img
        /* perf batch 3: .product-fbt__img renders 136px @1440 / 79px @390 (measured) */
        ? '<img' + swImgAttrs(img, { src: 280, slot: 136, sizes: '(max-width: 767px) 79px, 136px' }) + ' alt="' + escAttr(p.title) + '" loading="lazy">'
        : '';
      var bv = isCurrent
        ? bestVariant(current) || (current.variants && current.variants[0])
        : bestVariant(p) || (p.variants && p.variants[0]);
      var variantId = bv ? bv.id : null;
      var priceKWD = bv ? toKWD(bv.price, isCurrent) : 0;
      var priceCents = window.SWMoney ? window.SWMoney.fromDecimal(priceKWD) : Math.round(priceKWD * 100);
      var priceDisplay = priceKWD > 0 ? (window.SWMoney ? window.SWMoney.formatMoney(priceCents) : priceKWD.toFixed(2)) : ''; /* money-sweep */
      var checkLabelKey = isCurrent ? 'products.fbt.this_item' : 'products.fbt.include';
      var checkLabelEn  = isCurrent ? 'This item' : 'Include';
      var checkLabel    = checkLabelEn;
      return '<div class="product-fbt__item" data-fbt-item data-variant-id="' + escAttr(variantId) + '" data-price-cents="' + escAttr(priceCents) + '">' +
        '<div class="product-fbt__img">' + imgHtml + '</div>' +
        '<p class="product-fbt__title">' + escHtml((p.title || '').substr(0, 40)) + '</p>' +
        '<p class="product-fbt__price">' + escHtml(priceDisplay) + '</p>' +
        '<label class="product-fbt__check-row">' +
          '<input type="checkbox" class="product-fbt__check" data-fbt-check ' + (checked ? 'checked' : '') + ' ' + (isCurrent ? 'data-current' : '') + '>' +
          '<span class="product-fbt__check-label" data-i18n="' + checkLabelKey + '">' + escHtml(checkLabel) + '</span>' +
        '</label>' +
        '</div>';
    }

    function recalcTotal() {
      var cents = 0;
      row.querySelectorAll('[data-fbt-item]').forEach(function(it) {
        var cb = it.querySelector('[data-fbt-check]');
        if (cb && cb.checked) cents += parseFloat(it.getAttribute('data-price-cents')) || 0;
      });
      /* money-sweep: cents = Shopify cents (price × 100, may be fractional for 3-decimal currencies) → assets/money.js */
      if (totalEl) totalEl.textContent = window.SWMoney ? window.SWMoney.formatMoney(cents) : (cents / 100).toFixed(2);
    }

    function renderAll(picks) {
      var items = [current].concat(picks);
      var html = items.map(function(p, i) {
        return fbtItemHtml(p, true, i === 0) + (i < items.length - 1 ? '<span class="product-fbt__plus" aria-hidden="true">+</span>' : '');
      }).join('');
      row.innerHTML = html;
      recalcTotal();
      section.hidden = false;
      window.dispatchEvent(new CustomEvent('sw:cards-rendered', { detail: { scope: section } }));
    }

    row.addEventListener('change', function(e) {
      if (e.target && e.target.hasAttribute && e.target.hasAttribute('data-fbt-check')) recalcTotal();
    });

    if (addAllBtn) addAllBtn.addEventListener('click', function() {
      var items = [];
      row.querySelectorAll('[data-fbt-item]').forEach(function(it) {
        var cb = it.querySelector('[data-fbt-check]');
        if (!cb || !cb.checked) return;
        var vid = it.getAttribute('data-variant-id');
        if (vid && vid !== 'null' && vid !== 'undefined') items.push({ id: parseInt(vid, 10), quantity: 1 });
      });
      if (!items.length) return;
      addAllBtn.disabled = true;
      var originalText = addAllBtn.textContent;
      addAllBtn.textContent = 'Adding…';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function(r) { return r.json().then(function(b) { if (!r.ok) { throw new Error((b && (b.description || b.message)) || 'Could not add all items'); } return b; }); })
        .then(function() {
          if (!document.getElementById('cart-drawer')) return null; /* WS-19: no drawer mounted → skip the section fetch */
          return fetch('/?sections=cart-drawer', { headers: { 'Accept': 'application/json' } });
        })
        .then(function(r) { return r ? r.json() : null; })
        .then(function(sections) {
          if (sections && sections['cart-drawer']) {
            var wrap = document.createElement('div');
            wrap.innerHTML = sections['cart-drawer'];
            var fresh = wrap.querySelector('#cart-drawer');
            var existing = document.getElementById('cart-drawer');
            if (fresh && existing) existing.innerHTML = fresh.innerHTML;
          }
          return fetch('/cart.js').then(function(r) { return r.json(); });
        })
        .then(function(cart) {
          document.querySelectorAll('.header__cart-count').forEach(function(el) {
            el.textContent = cart.item_count;
            el.style.display = cart.item_count > 0 ? 'flex' : 'none';
          });
          if (window.swToast) window.swToast('Added to cart · ' + items.length + ' items · بكل بساطة');
          /* Drawer intentionally NOT auto-opened here — toast is the confirmation.
             User can click the cart icon to view. */
        })
        .catch(function() {
          if (window.swToast) window.swToast('Could not add all items', { variant: 'error' });
        })
        .then(function() {
          addAllBtn.disabled = false;
          addAllBtn.textContent = originalText;
        });
    });

    /* Deep-fetch: sparse categories (System boots, tube ropes) can sit far
       down the best-selling order. Keep paging until both FBT slots fill or
       the page cap hits — early-exits on rich stores, digs deep on sparse. */
    var FBT_PAGE_CAP = 8;
    function fillPicks(page) {
      var picks = pick2(storeCache.products);
      if (picks.length >= 2 || page > FBT_PAGE_CAP ||
          (storeCache.exhaustedPage && page > storeCache.exhaustedPage)) {
        if (picks.length >= 1) renderAll(picks);
        return;
      }
      fetchStorePage(page).then(function() { fillPicks(page + 1); });
    }
    fetchStorePage(1).then(function() { return fetchStorePage(2); }).then(function() {
      fillPicks(3);
    });
  })();

  /* ===== YOU MAY ALSO LIKE — infinite scroll + variety enforcement ===== */
  (function ymal() {
    var container = document.querySelector('[data-infinite-scroll]');
    if (!container) return;
    var productId = container.getAttribute('data-product-id');
    var currentHandle = container.getAttribute('data-product-handle') || '';
    var loading = false;
    var exhausted = false;
    var page = 1;
    var seedDone = false;
    var lastType = null;
    var sameTypeCount = 0;

    function shownHandles() {
      var map = {};
      container.querySelectorAll('a[href]').forEach(function(a) {
        var href = a.getAttribute('href');
        if (href) map[href.replace(/\?.*$/, '')] = true;
      });
      return map;
    }

    function appendProducts(products) {
      if (!products || !products.length) return 0;
      /* Drop sold-out / zero-priced defensively */
      products = products.filter(isShowable);
      if (!products.length) return 0;
      var shown = shownHandles();
      var appended = 0;
      /* Variety pass: shuffle by type so we don't emit 5 wakeboards in a row */
      var byType = {};
      products.forEach(function(p) {
        if (!p) return;
        var cat = categorize(p) || '_other';
        (byType[cat] = byType[cat] || []).push(p);
      });
      var types = Object.keys(byType);
      if (types.length > 1) {
        var interleaved = [];
        var max = types.reduce(function(m, t) { return Math.max(m, byType[t].length); }, 0);
        for (var i = 0; i < max; i++) types.forEach(function(t) { if (byType[t][i]) interleaved.push(byType[t][i]); });
        products = interleaved;
      }
      products.forEach(function(p) {
        if (!p.handle) return;
        if (p.handle === currentHandle) return;
        var url = p.url || ('/products/' + p.handle);
        var key = url.replace(/\?.*$/, '');
        if (shown[key]) return;
        var cat = categorize(p);
        if (cat && cat === lastType) {
          sameTypeCount++;
          if (sameTypeCount >= 3) return; /* Variety gate */
        } else {
          sameTypeCount = 0;
          lastType = cat;
        }
        container.insertAdjacentHTML('beforeend', recCardHtml(p));
        shown[key] = true;
        appended++;
      });
      if (appended > 0) {
        window.dispatchEvent(new CustomEvent('sw:cards-rendered', { detail: { scope: container } }));
      }
      return appended;
    }

    /* 2026-09-05 hotfix (source-aware prices): /recommendations/products.json is Shopify's Ajax shape — prices are
       INTEGER cents (x100 for EVERY currency, KWD included) — while priceText()/isShowable() below expect the
       /products.json DECIMAL-string shape. Without this seam, recs-seeded cards rendered x100 ("14090.000 KWD"
       for a 140.900 board — live safewakekw.com, 2026-09-05). Normalise once, at the seam; nothing else changes. */
    function swAjaxToFeedShape(p) {
      if (!p || p.__swFeedShape) return p;
      var dec = function(c) { return (c == null || c === '') ? null : (Number(c) / 100).toFixed(3); };
      var q = {}; for (var k in p) if (Object.prototype.hasOwnProperty.call(p, k)) q[k] = p[k];
      q.__swFeedShape = true;
      if (q.price != null) q.price = dec(q.price);
      if (q.price_min != null) q.price_min = dec(q.price_min);
      if (q.price_max != null) q.price_max = dec(q.price_max);
      if (q.compare_at_price != null) q.compare_at_price = dec(q.compare_at_price);
      if (q.variants && q.variants.length) q.variants = q.variants.map(function(v) {
        var w = {}; for (var k2 in v) if (Object.prototype.hasOwnProperty.call(v, k2)) w[k2] = v[k2];
        w.price = dec(v.price); w.compare_at_price = dec(v.compare_at_price); return w;
      });
      return q;
    }
    function seedFromShopifyRecs() {
      if (seedDone || !productId) return Promise.resolve();
      seedDone = true;
      return fetch(swFresh('/recommendations/products.json?product_id=' + productId + '&limit=12&intent=related'), {
        headers: { 'Accept': 'application/json' }
      })
        .then(function(r) { return r.json(); })
        .then(function(data) {
          if (data && data.products && data.products.length) appendProducts(data.products.map(swAjaxToFeedShape));   /* 2026-09-05 hotfix: Ajax cents -> feed decimals */
        })
        .catch(function() {});
    }

    function loadMore() {
      if (loading || exhausted) return;
      loading = true;
      var step = seedDone ? Promise.resolve() : seedFromShopifyRecs();
      step.then(function() {
        if (storeCache.products.length > 0) {
          var added = appendProducts(storeCache.products);
          if (added > 0) { loading = false; return; }
        }
        if (storeCache.exhaustedPage && page > storeCache.exhaustedPage) { exhausted = true; loading = false; return; }
        return fetchStorePage(page).then(function(arr) {
          page++;
          var added = appendProducts(arr);
          if (added === 0 && (storeCache.exhaustedPage || arr.length === 0)) exhausted = true;
        });
      }).then(function() { loading = false; }).catch(function() { loading = false; });
    }

    container.addEventListener('scroll', function() {
      if (container.scrollLeft + container.clientWidth > container.scrollWidth - 300) loadMore();
    }, { passive: true });

    /* DO NOT wipe Liquid-seeded fallback at init — if JS rec engine fails or finds
       nothing, the user still sees the Liquid cards. The appendProducts() dedup logic
       (shownHandles()) ensures smart picks don't duplicate Liquid seeds. */

    /* Eager initial seed */
    setTimeout(loadMore, 200);
  })();

  /* ===== Star rating render from data-stars-display ===== */
  function renderStars(el, rating) {
    var r = parseFloat(rating) || 0;
    if (r <= 0) return;
    var html = '';
    for (var i = 1; i <= 5; i++) {
      var fill;
      if (r >= i) fill = 'full';
      else if (r > i - 1) fill = 'half';
      else fill = 'empty';
      var color = (fill === 'empty') ? 'rgb(var(--color-border))' : '#F59E0B';
      var gradientId = 'sw-star-half-' + Math.random().toString(36).slice(2, 7);
      if (fill === 'half') {
        html += '<svg viewBox="0 0 24 24" aria-hidden="true">' +
          '<defs><linearGradient id="' + gradientId + '"><stop offset="50%" stop-color="#F59E0B"/><stop offset="50%" stop-color="rgb(var(--color-border))"/></linearGradient></defs>' +
          '<path fill="url(#' + gradientId + ')" d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/></svg>';
      } else {
        html += '<svg viewBox="0 0 24 24" aria-hidden="true">' +
          '<path fill="' + color + '" d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/></svg>';
      }
    }
    el.innerHTML = html;
  }
  document.querySelectorAll('[data-stars-display]').forEach(function(el) {
    renderStars(el, el.getAttribute('data-stars-display'));
  });

  /* ===== Reviews form ===== */
  (function reviews() {
    var openBtn = document.querySelector('[data-reviews-open]');
    var form = document.querySelector('[data-reviews-form]');
    var cancelBtn = document.querySelector('[data-reviews-cancel]');
    var picker = document.querySelector('[data-rating-picker]');
    var ratingInput = document.querySelector('[data-review-rating-input]');
    if (!openBtn || !form) return;

    openBtn.addEventListener('click', function() {
      form.hidden = false;
      openBtn.hidden = true;
    });
    if (cancelBtn) cancelBtn.addEventListener('click', function() {
      form.hidden = true;
      openBtn.hidden = false;
    });
    if (picker) {
      var stars = picker.querySelectorAll('[data-rating]');
      picker.addEventListener('click', function(e) {
        var btn = e.target.closest('[data-rating]');
        if (!btn) return;
        var val = parseInt(btn.getAttribute('data-rating'), 10);
        if (!val) return;
        stars.forEach(function(s) {
          var sv = parseInt(s.getAttribute('data-rating'), 10);
          s.classList.toggle('is-active', sv <= val);
        });
        if (ratingInput) ratingInput.value = val;
      });
    }
    /* Build final contact[body] with rating prefix on submit */
    form.addEventListener('submit', function(e) {
      var bodyField = form.querySelector('textarea[name="contact[body]"]');
      var rating = ratingInput ? parseInt(ratingInput.value, 10) : 0;
      if (!rating) {
        e.preventDefault();
        alert('Please select a star rating.');
        return;
      }
      if (bodyField && bodyField.value.indexOf('Rating:') !== 0) {
        bodyField.value = 'Rating: ' + rating + '/5\n\n' + bodyField.value;
      }
    });
  })();

  /* ===== Jump-to-reviews from star rating click ===== */
  document.querySelectorAll('[data-rating-jump]').forEach(function(el) {
    el.addEventListener('click', function(e) {
      e.preventDefault();
      var reviewsBtn = document.querySelector('.product-tabs__tab[data-tab="reviews"]');
      if (reviewsBtn) reviewsBtn.click();
      var anchor = document.getElementById('product-tabs-anchor');
      if (anchor) anchor.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  });
})();

/* === Sticky mobile Add to Cart bar === */
(function() {
  var bar = document.querySelector('[data-sticky-atc]');
  if (!bar) return;
  var mainAtc = document.querySelector('.product-form__atc');
  var btn = bar.querySelector('[data-sticky-atc-btn]');
  if (!mainAtc || !btn) return;

  document.body.classList.add('has-sticky-atc');

  function update() {
    if (window.innerWidth >= 768) return bar.classList.remove('is-visible');
    var rect = mainAtc.getBoundingClientRect();
    var offScreen = rect.bottom < 0 || rect.top > window.innerHeight;
    bar.classList.toggle('is-visible', offScreen);
  }
  update();
  window.addEventListener('scroll', update, { passive: true });
  window.addEventListener('resize', update);

  btn.addEventListener('click', function() {
    var form = document.querySelector('form[action*="/cart/add"]');
    if (form) {
      if (form.requestSubmit) form.requestSubmit();
      else form.submit();
    }
  });
})();

/* === Product Page Tabs — accordion behavior
   Click inactive tab: open that tab (close others).
   Click currently-active tab: close it (no tab selected — all panels hidden).
   On page load: close all tabs by default so users CHOOSE what to read. */
(function() {
  var tabs = document.querySelector('[data-product-tabs]');
  if (!tabs) return;
  var tabBtns = tabs.querySelectorAll('.product-tabs__tab');
  var panels = tabs.querySelectorAll('.product-tabs__panel');

  function closeAll() {
    tabBtns.forEach(function(b) {
      b.classList.remove('active');
      b.setAttribute('aria-selected', 'false');
    });
    panels.forEach(function(p) {
      p.hidden = true;
      p.classList.remove('active');
    });
  }

  function openTab(id) {
    tabBtns.forEach(function(b) {
      var on = b.getAttribute('data-tab') === id;
      b.classList.toggle('active', on);
      b.setAttribute('aria-selected', on ? 'true' : 'false');
    });
    panels.forEach(function(p) {
      var show = p.getAttribute('data-panel') === id;
      p.hidden = !show;
      p.classList.toggle('active', show);
    });
  }

  /* Desktop: description expanded by default (founder request). Mobile: collapsed. */
  if (window.matchMedia && window.matchMedia('(min-width: 768px)').matches) {
    openTab('description');
  } else {
    closeAll();
  }

  tabBtns.forEach(function(btn) {
    btn.addEventListener('click', function() {
      var id = btn.getAttribute('data-tab');
      if (btn.classList.contains('active')) {
        /* Click active tab → close it */
        closeAll();
      } else {
        openTab(id);
      }
    });
  });
})();

/* === Price Alert Toggle === */
(function() {
  var openBtn = document.querySelector('[data-price-alert-open]');
  var panel = document.querySelector('[data-price-alert]');
  if (!openBtn || !panel) return;
  openBtn.addEventListener('click', function() {
    panel.hidden = !panel.hidden;
    if (!panel.hidden) {
      var email = panel.querySelector('input[type="email"]');
      if (email) email.focus();
    }
  });
})();

/* === Collection Infinite Scroll (self-healing across AJAX collection switches) === */
(function() {
  var root = document.querySelector('[data-infinite-collection]');
  if (!root) return;

  function getState() {
    var sentinel = root.querySelector('.coll-infinite-sentinel');
    var grid = root.querySelector('.coll-product-grid');
    return { sentinel: sentinel, grid: grid };
  }

  var loading = false;
  var exhausted = false;
  var io = null;
  var observedSentinel = null;

  function attachObserver() {
    var sentinel = root.querySelector('.coll-infinite-sentinel');
    if (!sentinel || sentinel === observedSentinel) return;
    if (io) io.disconnect();
    io = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) { if (entry.isIntersecting) loadMore(); });
    }, { rootMargin: '2400px 0px' });
    io.observe(sentinel);
    observedSentinel = sentinel;
    /* Reset exhausted when a new sentinel appears (AJAX switched collection) */
    exhausted = false;
    /* Eagerly prefetch next page immediately so content appears before user reaches it */
    setTimeout(loadMore, 120);
  }

  /* Re-attach when content changes (AJAX collection switch replaces innerHTML).
     Debounced; does NOT blanket-reset `exhausted` — that wiped the legitimate
     end-of-list flag on every card append, causing redundant refetches at the
     end of a collection. attachObserver() resets `exhausted` only when a
     genuinely new sentinel node appears (a real collection switch). */
  var moTimer = null;
  var mo = new MutationObserver(function() {
    if (moTimer) return;
    moTimer = setTimeout(function() { moTimer = null; attachObserver(); }, 150);
  });
  mo.observe(root, { childList: true, subtree: true });

  function loadMore() {
    if (loading || exhausted) return;
    var state = getState();
    if (!state.sentinel || !state.grid) { exhausted = true; return; }
    var nextUrl = state.sentinel.getAttribute('data-next-url');
    if (!nextUrl) { exhausted = true; return; }
    loading = true;
    state.sentinel.classList.add('is-loading');

    fetch(nextUrl, { headers: { 'Accept': 'text/html' } })
      .then(function(r) { return r.text(); })
      .then(function(html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var newGrid = doc.querySelector('.coll-product-grid');
        var newSentinel = doc.querySelector('.coll-infinite-sentinel');
        var newEndMarker = doc.querySelector('[data-end-marker]');

        if (newGrid) {
          /* Append new product cards into the existing grid */
          var cards = newGrid.children;
          var frag = document.createDocumentFragment();
          while (cards.length) frag.appendChild(cards[0]);
          state.grid.appendChild(frag);
        }

        /* Replace the sentinel or show end-of-list marker */
        if (newSentinel) {
          state.sentinel.setAttribute('data-next-url', newSentinel.getAttribute('data-next-url'));
          state.sentinel.classList.remove('is-loading');
        } else if (newEndMarker) {
          state.sentinel.replaceWith(newEndMarker.cloneNode(true));
          exhausted = true;
        } else {
          state.sentinel.remove();
          exhausted = true;
        }
      })
      .catch(function() {
        var s = getState().sentinel;
        if (s) s.classList.remove('is-loading');
      })
      .then(function() { loading = false; });
  }

  /* Initial attach + scroll fallback for no-IntersectionObserver browsers */
  if (window.IntersectionObserver) {
    attachObserver();
  } else {
    window.addEventListener('scroll', throttledCheck, { passive: true });
  }

  var scrollTick = null;
  function throttledCheck() {
    if (scrollTick) return;
    scrollTick = requestAnimationFrame(function() {
      scrollTick = null;
      var s = root.querySelector('.coll-infinite-sentinel');
      if (!s) return;
      var rect = s.getBoundingClientRect();
      if (rect.top < window.innerHeight + 800) loadMore();
    });
  }
})();

/* === Cart page: auto-submit on quantity change + smart recommendations ===
   - Any +/- button or direct input change in /cart triggers form submit → cart refreshes
   - Reads [#cart-items-json] for items-in-cart, derives complementary categories,
     fetches /products.json and renders up to 6 cross-sell cards in the sidebar. */
(function() {
  var cartForm = document.getElementById('main-cart-form');
  if (!cartForm) return;

  /* Auto-submit on quantity change (debounced) */
  var submitTimer = null;
  function scheduleSubmit() {
    if (submitTimer) clearTimeout(submitTimer);
    submitTimer = setTimeout(function() { cartForm.submit(); }, 650);
  }
  cartForm.addEventListener('click', function(e) {
    if (e.target.closest('[data-qty-minus], [data-qty-plus]')) scheduleSubmit();
  });
  cartForm.addEventListener('change', function(e) {
    if (e.target.matches && e.target.matches('[data-cart-qty]')) scheduleSubmit();
  });

  /* --- Recommendations ---
     Runs on the cart page only. Uses the same categorize() + CROSS_SELL + isShowable
     from the rec engine IIFE above (functions are exposed via their closure
     when the rec engine script runs; however from a different IIFE we can't access
     them directly. So instead we fetch /products.json here too and re-implement
     the minimal category logic. Lightweight duplication < cross-IIFE coupling.) */
  var recsPanel = document.querySelector('[data-cart-recs]');
  var recsTrack = document.querySelector('[data-cart-recs-track]');
  var itemsEl = document.getElementById('cart-items-json');
  if (!recsPanel || !recsTrack || !itemsEl) return;

  var cartItems;
  try { cartItems = JSON.parse(itemsEl.textContent || '[]'); }
  catch (e) { return; }
  if (!cartItems.length) return;

  function norm(s) { return (s || '').toString().toLowerCase(); }
  /* Taxonomy v2 — delegate to the shared engine exported by the PDP rec-engine
     IIFE above (single source of truth; the old inline duplicate drifted and
     mis-categorized the canonical vault types). */
  function categorize(p) {
    return (window.SWRecEngine && window.SWRecEngine.categorize) ? window.SWRecEngine.categorize(p) : null;
  }
  var CROSS = (window.SWRecEngine && window.SWRecEngine.CROSS_SELL) || {};
  function isShowable(p) {
    if (!p) return false;
    if (p.variants && p.variants.length) {
      return p.variants.some(function(v) {
        if (v.available === false) return false;
        var price = parseFloat(v.price);
        return isFinite(price) && price > 0;
      });
    }
    return false;
  }
  function priceOf(p) {
    if (p.variants && p.variants.length) {
      for (var i = 0; i < p.variants.length; i++) {
        var v = p.variants[i];
        if (v && v.available !== false && v.price) return parseFloat(v.price);
      }
    }
    return 0;
  }
  /* perf batch 3: extraction only — sized at the call site through swImgAttrs()
     (same reason as extractImage() above: the old guard skipped //cdn URLs). */
  function imgOf(p) {
    var img = p.featured_image || (p.images && p.images[0]) || '';
    if (img && typeof img === 'object') img = img.src;
    return img;
  }
  function escHtml(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function(c) { return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]; }); }

  /* 1. Compute wanted categories from items in cart */
  var wanted = {};
  var cartHandles = {};
  cartItems.forEach(function(ci) {
    cartHandles[ci.handle] = true;
    var cat = categorize(ci);
    if (!cat) return;
    (CROSS[cat] || []).forEach(function(w) { wanted[w] = true; });
  });
  if (!Object.keys(wanted).length) return;

  /* 2. Fetch store catalog pages, render up to 6 matching picks */
  var allFetched = [];
  function fetchPage(page) {
    return fetch(swFresh('/products.json?limit=50&page=' + page), { headers: {'Accept':'application/json'} })
      .then(function(r){ return r.json(); })
      .then(function(data){
        return (data && data.products) || [];
      })
      .catch(function(){ return []; });
  }

  fetchPage(1).then(function(a){ return fetchPage(2).then(function(b){ return a.concat(b); }); })
    .then(function(products) {
      var picks = [];
      var catCount = {};
      products.forEach(function(p) {
        if (picks.length >= 6) return;
        if (!p.handle || cartHandles[p.handle]) return;
        if (!isShowable(p)) return;
        var cat = categorize(p);
        if (!cat || !wanted[cat]) return;
        catCount[cat] = (catCount[cat] || 0) + 1;
        if (catCount[cat] > 2) return; /* variety: max 2 per category */
        picks.push(p);
      });
      if (picks.length === 0) return;

      recsTrack.innerHTML = picks.map(function(p) {
        var variantId = p.variants && p.variants[0] && p.variants[0].id;
        var price = priceOf(p);
        var priceStr = window.SWMoney ? window.SWMoney.formatMoney(window.SWMoney.fromDecimal(price)) : price.toFixed(2); /* money-sweep: /products.json decimal → market currency */
        var img = imgOf(p);
        /* perf batch 3: .cart-rec-card is flex 0 0 130px (sections/main-cart.liquid:81) */
        var imgHtml = img ? '<img' + swImgAttrs(img, { src: 280, slot: 130 }) + ' alt="' + escHtml(p.title) + '" loading="lazy">' : '';
        return '<a href="/products/' + escHtml(p.handle) + '" class="cart-rec-card">'
          + '<div class="cart-rec-card__img">' + imgHtml
          + (variantId ? '<form action="/cart/add" method="post" style="position:absolute;inset:0;pointer-events:none"><input type="hidden" name="id" value="' + variantId + '"><button type="submit" class="cart-rec-card__add" aria-label="Add to cart" style="pointer-events:auto"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg></button></form>' : '')
          + '</div>'
          + '<p class="cart-rec-card__vendor">' + escHtml(p.vendor || '') + '</p>'
          + '<p class="cart-rec-card__title">' + escHtml(p.title || '') + '</p>'
          + '<p class="cart-rec-card__price">' + escHtml(priceStr) + '</p>'
          + '</a>';
      }).join('');
      recsPanel.hidden = false;
    });
})();



  /* v8 — Country switcher (KW/SA/AE) toggle */
  document.addEventListener('click', function(e) {
    var toggle = e.target.closest('[data-country-switcher-toggle]');
    if (toggle) {
      e.preventDefault();
      var switcher = toggle.closest('[data-country-switcher]');
      var panel = switcher.querySelector('[data-country-switcher-panel]');
      var isOpen = !panel.hidden;
      /* close any other open switcher panels */
      document.querySelectorAll('[data-country-switcher-panel]').forEach(function(p) {
        if (p !== panel) {
          p.hidden = true;
          var t = p.parentElement.querySelector('[data-country-switcher-toggle]');
          if (t) t.setAttribute('aria-expanded', 'false');
        }
      });
      panel.hidden = isOpen;
      toggle.setAttribute('aria-expanded', String(!isOpen));
      return;
    }
    if (!e.target.closest('[data-country-switcher-panel]')) {
      document.querySelectorAll('[data-country-switcher-panel]').forEach(function(p) { p.hidden = true; });
      document.querySelectorAll('[data-country-switcher-toggle]').forEach(function(t) { t.setAttribute('aria-expanded', 'false'); });
    }
  });
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') {
      document.querySelectorAll('[data-country-switcher-panel]').forEach(function(p) { p.hidden = true; });
      document.querySelectorAll('[data-country-switcher-toggle]').forEach(function(t) { t.setAttribute('aria-expanded', 'false'); });
    }
  });


  /* v12 — iOS touchstart fallback for close-on-outside (Mobile Safari sometimes doesn't
     fire delegated `click` events on non-interactive targets). */
  document.addEventListener('touchstart', function(e) {
    if (e.target.closest('[data-country-switcher]')) return;  /* let click handle the toggle */
    var anyOpen = document.querySelector('[data-country-switcher-panel]:not([hidden])');
    if (!anyOpen) return;
    document.querySelectorAll('[data-country-switcher-panel]').forEach(function(p) { p.hidden = true; });
    document.querySelectorAll('[data-country-switcher-toggle]').forEach(function(t) { t.setAttribute('aria-expanded', 'false'); });
  }, { passive: true });


/* ── SafeWake ONE · perf batch 1 (2026-09-12) — LAZY BACKGROUND VIDEO ──────────
   The three home-page video bands ship with preload="none" + poster and NO src
   (sections/brand-video-hero.liquid, sections/lifestyle-video.liquid). Each
   [data-sw-lazy-video] gets its rendition only when it scrolls within 300px of
   the viewport: 480p on a narrow screen or Save-Data, 720p otherwise, the
   original URL as the last resort. Pauses when it leaves. reduced-motion is NOT
   honoured here on purpose: the live theme autoplays, and same-behaviour is the
   brief (proxy ruling 2026-09-12). Replaces three autoplaying
   preload="auto" originals (286 MB of MP4 pulled at first paint). */
(function () {
  var vids = document.querySelectorAll('video[data-sw-lazy-video]');
  if (!vids.length) return;

  var mq = window.matchMedia;

  function pick(v) {
    var narrow = mq ? mq('(max-width: 768px)').matches : false;
    var conn = navigator.connection || {};
    if ((narrow || conn.saveData) && v.getAttribute('data-src-480')) return v.getAttribute('data-src-480');
    return v.getAttribute('data-src-720') || v.getAttribute('data-src') || '';
  }

  /* perf batch 4 (2026-09-12): a play() issued in the same tick as load() on a
     freshly-set src is rejected or dropped by Chromium — measured on the preview
     theme, where the band attached its 720p source and buffered 21 s while the
     element stayed paused, yet a direct v.play() on that same element started it
     immediately. So: ask, and if the promise rejects, ask once more when the
     element says it can actually play. A genuine autoplay refusal still just
     leaves the poster up. */
  function attempt(v) {
    var p = v.play();
    if (p && p.catch) p.catch(function () {
      v.addEventListener('canplay', function () {
        var q = v.play();
        if (q && q.catch) q.catch(function () {});   /* still refused → poster stays */
      }, { once: true });
    });
  }

  function start(v) {
    if (!v.getAttribute('src')) {
      var src = pick(v);
      if (!src) return;
      v.setAttribute('src', src);
      v.load();
    }
    attempt(v);
  }

  if (!('IntersectionObserver' in window)) {     /* old browser: one load each, no observer */
    Array.prototype.forEach.call(vids, start);
    return;
  }

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (!e.isIntersecting) {
        if (e.target.getAttribute('src')) e.target.pause();
        return;
      }
      /* already sourced but sitting paused (see attempt() above) → ask again;
         otherwise this is the first intersection: attach the rendition and play */
      if (e.target.getAttribute('src') && e.target.paused) attempt(e.target);
      else start(e.target);
    });
  }, { rootMargin: '300px 0px' });

  Array.prototype.forEach.call(vids, function (v) { io.observe(v); });
})();
